"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconDsfrLineChartFill = exports.iconDsfrGlobalLine = exports.iconDsfrGlobalFill = exports.iconDsfrFlagLine = exports.iconDsfrFlagFill = exports.iconDsfrCustomerServiceLine = exports.iconDsfrCustomerServiceFill = exports.iconDsfrCopyrightLine = exports.iconDsfrCopyrightFill = exports.iconDsfrCloudLine = exports.iconDsfrCloudFill = exports.iconDsfrCalendarLine = exports.iconDsfrCalendarFill = exports.iconDsfrCalendarEventLine = exports.iconDsfrCalendarEventFill = exports.iconDsfrCalendar2Line = exports.iconDsfrCalendar2Fill = exports.iconDsfrBriefcaseLine = exports.iconDsfrBriefcaseFill = exports.iconDsfrBookmarkLine = exports.iconDsfrBookmarkFill = exports.iconDsfrBarChartBoxLine = exports.iconDsfrBarChartBoxFill = exports.iconDsfrAwardLine = exports.iconDsfrAwardFill = exports.iconDsfrAttachmentLine = exports.iconDsfrAttachmentFill = exports.iconDsfrArchiveLine = exports.iconDsfrArchiveFill = exports.dsfrIconsBuilding = exports.iconDsfrStoreLine = exports.iconDsfrStoreFill = exports.iconDsfrHotelLine = exports.iconDsfrHotelFill = exports.iconDsfrHospitalLine = exports.iconDsfrHospitalFill = exports.iconDsfrHome4Line = exports.iconDsfrHome4Fill = exports.iconDsfrGovernmentLine = exports.iconDsfrGovernmentFill = exports.iconDsfrCommunityLine = exports.iconDsfrCommunityFill = exports.iconDsfrBuildingLine = exports.iconDsfrBuildingFill = exports.iconDsfrBankLine = exports.iconDsfrBankFill = exports.iconDsfrAncientPavilionLine = exports.iconDsfrAncientPavilionFill = exports.iconDsfrAncientGateLine = exports.iconDsfrAncientGateFill = void 0;
exports.iconDsfrBallPenFill = exports.dsfrIconsCommunication = exports.iconDsfrVideoChatLine = exports.iconDsfrVideoChatFill = exports.iconDsfrQuestionnaireLine = exports.iconDsfrQuestionnaireFill = exports.iconDsfrQuestionAnswerLine = exports.iconDsfrQuestionAnswerFill = exports.iconDsfrMessage2Line = exports.iconDsfrMessage2Fill = exports.iconDsfrFeedbackLine = exports.iconDsfrFeedbackFill = exports.iconDsfrDiscussLine = exports.iconDsfrDiscussFill = exports.iconDsfrChatPollLine = exports.iconDsfrChatPollFill = exports.iconDsfrChatDeleteLine = exports.iconDsfrChatDeleteFill = exports.iconDsfrChatCheckLine = exports.iconDsfrChatCheckFill = exports.iconDsfrChat3Line = exports.iconDsfrChat3Fill = exports.iconDsfrChat2Line = exports.iconDsfrChat2Fill = exports.dsfrIconsBusiness = exports.iconDsfrWindowLine = exports.iconDsfrWindowFill = exports.iconDsfrSlideshowLine = exports.iconDsfrSlideshowFill = exports.iconDsfrSendPlaneLine = exports.iconDsfrSendPlaneFill = exports.iconDsfrProjector2Line = exports.iconDsfrProjector2Fill = exports.iconDsfrProfilLine = exports.iconDsfrProfilFill = exports.iconDsfrPrinterLine = exports.iconDsfrPrinterFill = exports.iconDsfrPieChartBoxLine = exports.iconDsfrPieChartBoxFill = exports.iconDsfrPieChart2Line = exports.iconDsfrPieChart2Fill = exports.iconDsfrMedalLine = exports.iconDsfrMedalFill = exports.iconDsfrMailOpenLine = exports.iconDsfrMailOpenFill = exports.iconDsfrMailLine = exports.iconDsfrMailFill = exports.iconDsfrLinksLine = exports.iconDsfrLinksFill = exports.iconDsfrLineChartLine = void 0;
exports.iconDsfrCursorFill = exports.iconDsfrCodeSSlashLine = exports.iconDsfrCodeBoxLine = exports.iconDsfrCodeBoxFill = exports.iconDsfrBugLine = exports.iconDsfrBugFill = exports.dsfrIconsDesign = exports.iconDsfrShapesLine = exports.iconDsfrShapesFill = exports.iconDsfrTableLine = exports.iconDsfrTableFill = exports.iconDsfrSipLine = exports.iconDsfrSipFill = exports.iconDsfrPencilRulerLine = exports.iconDsfrPencilRulerFill = exports.iconDsfrPencilLine = exports.iconDsfrPencilFill = exports.iconDsfrPenNibLine = exports.iconDsfrPenNibFill = exports.iconDsfrPantoneLine = exports.iconDsfrPantoneFill = exports.iconDsfrPaletteLine = exports.iconDsfrPaletteFill = exports.iconDsfrPaintLine = exports.iconDsfrPaintFill = exports.iconDsfrPaintBrushLine = exports.iconDsfrPaintBrushFill = exports.iconDsfrMarkPenLine = exports.iconDsfrMarkPenFill = exports.iconDsfrLayoutGridLine = exports.iconDsfrLayoutGridFill = exports.iconDsfrInkBottleLine = exports.iconDsfrInkBottleFill = exports.iconDsfrEditLine = exports.iconDsfrEditFill = exports.iconDsfrEditBoxLine = exports.iconDsfrEditBoxFill = exports.iconDsfrDropLine = exports.iconDsfrDropFill = exports.iconDsfrDragMove2Line = exports.iconDsfrDragMove2Fill = exports.iconDsfrCropLine = exports.iconDsfrCropFill = exports.iconDsfrContrastLine = exports.iconDsfrContrastFill = exports.iconDsfrBrushLine = exports.iconDsfrBrushFill = exports.iconDsfrBrush3Line = exports.iconDsfrBrush3Fill = exports.iconDsfrBallPenLine = void 0;
exports.iconDsfrTabletFill = exports.iconDsfrSmartphoneLine = exports.iconDsfrSmartphoneFill = exports.iconDsfrServerLine = exports.iconDsfrServerFill = exports.iconDsfrSaveLine = exports.iconDsfrSaveFill = exports.iconDsfrSave3Line = exports.iconDsfrSave3Fill = exports.iconDsfrRssLine = exports.iconDsfrRssFill = exports.iconDsfrQrCodeLine = exports.iconDsfrQrCodeFill = exports.iconDsfrPhoneLine = exports.iconDsfrPhoneFill = exports.iconDsfrMacLine = exports.iconDsfrMacFill = exports.iconDsfrHardDrive2Line = exports.iconDsfrHardDrive2Fill = exports.iconDsfrDeviceLine = exports.iconDsfrDeviceFill = exports.iconDsfrDatabaseLine = exports.iconDsfrDatabaseFill = exports.iconDsfrDashboard3Line = exports.iconDsfrDashboard3Fill = exports.iconDsfrComputerLine = exports.iconDsfrComputerFill = exports.iconDsfrBluetoothLine = exports.iconDsfrBluetoothFill = exports.dsfrIconsDevelopment = exports.iconDsfrTerminalWindowLine = exports.iconDsfrTerminalWindowFill = exports.iconDsfrTerminalLine = exports.iconDsfrTerminalBoxLine = exports.iconDsfrTerminalBoxFill = exports.iconDsfrGitRepositoryPrivateLine = exports.iconDsfrGitRepositoryPrivateFill = exports.iconDsfrGitRepositoryLine = exports.iconDsfrGitRepositoryFill = exports.iconDsfrGitRepositoryCommitsLine = exports.iconDsfrGitRepositoryCommitsFill = exports.iconDsfrGitPullRequestLine = exports.iconDsfrGitPullRequestFill = exports.iconDsfrGitMergeLine = exports.iconDsfrGitMergeFill = exports.iconDsfrGitCommitLine = exports.iconDsfrGitCommitFill = exports.iconDsfrGitBranchLine = exports.iconDsfrGitBranchFill = exports.iconDsfrCursorLine = void 0;
exports.iconDsfrLinkUnlink = exports.iconDsfrItalic = exports.iconDsfrHashtag = exports.iconDsfrH6 = exports.iconDsfrH5 = exports.iconDsfrH4 = exports.iconDsfrH3 = exports.iconDsfrH2 = exports.iconDsfrH1 = exports.iconDsfrFontSize = exports.iconDsfrCodeView = exports.iconDsfrQuoteLine = exports.iconDsfrQuoteFill = exports.iconDsfrHighlight = exports.iconDsfrBold = exports.dsfrIconsDocument = exports.iconDsfrTodoLine = exports.iconDsfrTodoFill = exports.iconDsfrSurveyLine = exports.iconDsfrSurveyFill = exports.iconDsfrNewspaperLine = exports.iconDsfrNewspaperFill = exports.iconDsfrFolder2Line = exports.iconDsfrFolder2Fill = exports.iconDsfrFileTextLine = exports.iconDsfrFileTextFill = exports.iconDsfrFilePdfLine = exports.iconDsfrFilePdfFill = exports.iconDsfrFileLine = exports.iconDsfrFileFill = exports.iconDsfrFileDownloadLine = exports.iconDsfrFileDownloadFill = exports.iconDsfrFileAddLine = exports.iconDsfrFileAddFill = exports.iconDsfrDraftLine = exports.iconDsfrDraftFill = exports.iconDsfrClipboardLine = exports.iconDsfrClipboardFill = exports.iconDsfrBookletLine = exports.iconDsfrBookletFill = exports.iconDsfrBook2Line = exports.iconDsfrBook2Fill = exports.iconDsfrArticleLine = exports.iconDsfrArticleFill = exports.dsfrIconsDevice = exports.iconDsfrWifiLine = exports.iconDsfrWifiFill = exports.iconDsfrTvLine = exports.iconDsfrTvFill = exports.iconDsfrTabletLine = void 0;
exports.iconDsfrMentalHealthFill = exports.iconDsfrMedicineBottleLine = exports.iconDsfrMedicineBottleFill = exports.iconDsfrLungsLine = exports.iconDsfrLungsFill = exports.iconDsfrHeartPulseLine = exports.iconDsfrHeartPulseFill = exports.iconDsfrHeartLine = exports.iconDsfrHeartFill = exports.iconDsfrHealthBookLine = exports.iconDsfrHealthBookFill = exports.iconDsfrHandSanitizerLine = exports.iconDsfrHandSanitizerFill = exports.iconDsfrFirstAidKitLine = exports.iconDsfrFirstAidKitFill = exports.iconDsfrDossierLine = exports.iconDsfrDossierFill = exports.iconDsfrDislikeLine = exports.iconDsfrDislikeFill = exports.iconDsfrCapsuleLine = exports.iconDsfrCapsuleFill = exports.dsfrIconsFinance = exports.iconDsfrTrophyLine = exports.iconDsfrTrophyFill = exports.iconDsfrShoppingCart2Line = exports.iconDsfrShoppingCart2Fill = exports.iconDsfrShoppingBagLine = exports.iconDsfrShoppingBagFill = exports.iconDsfrSecurePaymentLine = exports.iconDsfrSecurePaymentFill = exports.iconDsfrMoneyEuroCircleLine = exports.iconDsfrMoneyEuroCircleFill = exports.iconDsfrMoneyEuroBoxLine = exports.iconDsfrMoneyEuroBoxFill = exports.iconDsfrGiftLine = exports.iconDsfrGiftFill = exports.iconDsfrCoinFill = exports.iconDsfrBankCardLine = exports.iconDsfrBankCardFill = exports.dsfrIconsEditor = exports.iconDsfrTranslate2 = exports.iconDsfrTable2 = exports.iconDsfrSuperscript = exports.iconDsfrSubscript = exports.iconDsfrSpace = exports.iconDsfrSeparator = exports.iconDsfrListQuestionMark = exports.iconDsfrListUnordered = exports.iconDsfrListOrdered = exports.iconDsfrLink = void 0;
exports.iconDsfrSlackFill = exports.iconDsfrSafariLine = exports.iconDsfrSafariFill = exports.iconDsfrRemixiconLine = exports.iconDsfrRemixiconFill = exports.iconDsfrNpmjsLine = exports.iconDsfrNpmjsFill = exports.iconDsfrMastodonLine = exports.iconDsfrMastodonFill = exports.iconDsfrLinkedinBoxLine = exports.iconDsfrLinkedinBoxFill = exports.iconDsfrInstagramLine = exports.iconDsfrInstagramFill = exports.iconDsfrIeLine = exports.iconDsfrIeFill = exports.iconDsfrGoogleLine = exports.iconDsfrGoogleFill = exports.iconDsfrGithubLine = exports.iconDsfrGithubFill = exports.iconDsfrFirefoxLine = exports.iconDsfrFirefoxFill = exports.iconDsfrFacebookCircleLine = exports.iconDsfrFacebookCircleFill = exports.iconDsfrEdgeLine = exports.iconDsfrEdgeFill = exports.iconDsfrChromeLine = exports.iconDsfrChromeFill = exports.iconDsfrTiktokLine = exports.iconDsfrTiktokFill = exports.iconDsfrDailymotionLine = exports.iconDsfrDailymotionFill = exports.dsfrIconsHealth = exports.iconDsfrVirusLine = exports.iconDsfrVirusFill = exports.iconDsfrThermometerLine = exports.iconDsfrThermometerFill = exports.iconDsfrTestTubeLine = exports.iconDsfrTestTubeFill = exports.iconDsfrSyringeLine = exports.iconDsfrSyringeFill = exports.iconDsfrSurgicalMaskLine = exports.iconDsfrSurgicalMaskFill = exports.iconDsfrStethoscopeLine = exports.iconDsfrStethoscopeFill = exports.iconDsfrPulseLine = exports.iconDsfrPsychotherapyLine = exports.iconDsfrPsychotherapyFill = exports.iconDsfrMicroscopeLine = exports.iconDsfrMicroscopeFill = exports.iconDsfrMentalHealthLine = void 0;
exports.iconDsfrPassportLine = exports.iconDsfrPassportFill = exports.iconDsfrMotorbikeLine = exports.iconDsfrMotorbikeFill = exports.iconDsfrMapPinUserLine = exports.iconDsfrMapPinUserFill = exports.iconDsfrMapPin2Line = exports.iconDsfrMapPin2Fill = exports.iconDsfrGobletLine = exports.iconDsfrGobletFill = exports.iconDsfrGasStationLine = exports.iconDsfrGasStationFill = exports.iconDsfrFranceLine = exports.iconDsfrFranceFill = exports.iconDsfrEarthLine = exports.iconDsfrEarthFill = exports.iconDsfrCupLine = exports.iconDsfrCupFill = exports.iconDsfrCompass3Line = exports.iconDsfrCompass3Fill = exports.iconDsfrChargingPile2Line = exports.iconDsfrChargingPile2Fill = exports.iconDsfrCaravanLine = exports.iconDsfrCaravanFill = exports.iconDsfrCarLine = exports.iconDsfrCarFill = exports.iconDsfrBusLine = exports.iconDsfrBusFill = exports.iconDsfrBikeLine = exports.iconDsfrBikeFill = exports.iconDsfrAnchorLine = exports.iconDsfrAnchorFill = exports.dsfrIconsLogo = exports.iconDsfrWhatsappLine = exports.iconDsfrWhatsappFill = exports.iconDsfrYoutubeLine = exports.iconDsfrYoutubeFill = exports.iconDsfrVuejsLine = exports.iconDsfrVuejsFill = exports.iconDsfrVimeoLine = exports.iconDsfrVimeoFill = exports.iconDsfrTwitterLine = exports.iconDsfrTwitterFill = exports.iconDsfrTwitchLine = exports.iconDsfrTwitchFill = exports.iconDsfrTelegramLine = exports.iconDsfrTelegramFill = exports.iconDsfrSnapchatLine = exports.iconDsfrSnapchatFill = exports.iconDsfrSlackLine = void 0;
exports.iconDsfrNotification3Fill = exports.iconDsfrMusic2Line = exports.iconDsfrMusic2Fill = exports.iconDsfrMicLine = exports.iconDsfrMicFill = exports.iconDsfrLiveLine = exports.iconDsfrLiveFill = exports.iconDsfrImageLine = exports.iconDsfrImageFill = exports.iconDsfrImageEditLine = exports.iconDsfrImageEditFill = exports.iconDsfrImageAddLine = exports.iconDsfrImageAddFill = exports.iconDsfrHeadphoneLine = exports.iconDsfrHeadphoneFill = exports.iconDsfrGalleryLine = exports.iconDsfrGalleryFill = exports.iconDsfrFilmLine = exports.iconDsfrFilmFill = exports.iconDsfrEqualizerLine = exports.iconDsfrEqualizerFill = exports.iconDsfrClapperboardLine = exports.iconDsfrClapperboardFill = exports.iconDsfrCameraLine = exports.iconDsfrCameraFill = exports.dsfrIconsMap = exports.iconDsfrStopCircleLine = exports.iconDsfrStopCircleFill = exports.iconDsfrPlayCircleLine = exports.iconDsfrPlayCircleFill = exports.iconDsfrThreadsLine = exports.iconDsfrThreadsFill = exports.iconDsfrXLine = exports.iconDsfrXFill = exports.iconDsfrTrainLine = exports.iconDsfrTrainFill = exports.iconDsfrTaxiLine = exports.iconDsfrTaxiFill = exports.iconDsfrSuitcase2Line = exports.iconDsfrSuitcase2Fill = exports.iconDsfrSignalTowerLine = exports.iconDsfrSignalTowerFill = exports.iconDsfrShip2Line = exports.iconDsfrShip2Fill = exports.iconDsfrSailboatLine = exports.iconDsfrSailboatFill = exports.iconDsfrRoadMapLine = exports.iconDsfrRoadMapFill = exports.iconDsfrRestaurantLine = exports.iconDsfrRestaurantFill = void 0;
exports.iconDsfrAddCircleLine = exports.iconDsfrAddCircleFill = exports.iconDsfrThemeFill = exports.iconDsfrWarningLine = exports.iconDsfrWarningFill = exports.iconDsfrSuccessLine = exports.iconDsfrSuccessFill = exports.iconDsfrInfoLine = exports.iconDsfrInfoFill = exports.iconDsfrErrorLine = exports.iconDsfrErrorFill = exports.iconDsfrArrowRightSLine = exports.iconDsfrArrowRightSFill = exports.iconDsfrArrowLeftSLine = exports.iconDsfrArrowLeftSFill = exports.dsfrIconsOthers = exports.iconDsfrWheelchairLine = exports.iconDsfrWheelchairFill = exports.iconDsfrSignLanguageLine = exports.iconDsfrSignLanguageFill = exports.iconDsfrMentalDisabilitiesLine = exports.iconDsfrMentalDisabilitiesFill = exports.iconDsfrEarOffLine = exports.iconDsfrEarOffFill = exports.iconDsfrAccessibilityLine = exports.iconDsfrAccessibilityFill = exports.iconDsfrUmbrellaLine = exports.iconDsfrUmbrellaFill = exports.iconDsfrSeedlingLine = exports.iconDsfrSeedlingFill = exports.iconDsfrScales3Line = exports.iconDsfrScales3Fill = exports.iconDsfrRecycleLine = exports.iconDsfrRecycleFill = exports.iconDsfrPlantLine = exports.iconDsfrPlantFill = exports.iconDsfrLightbulbLine = exports.iconDsfrLightbulbFill = exports.iconDsfrLeafLine = exports.iconDsfrLeafFill = exports.dsfrIconsMedia = exports.iconDsfrVolumeUpLine = exports.iconDsfrVolumeUpFill = exports.iconDsfrVolumeMuteLine = exports.iconDsfrVolumeMuteFill = exports.iconDsfrVolumeDownLine = exports.iconDsfrVolumeDownFill = exports.iconDsfrPauseCircleLine = exports.iconDsfrPauseCircleFill = exports.iconDsfrNotification3Line = void 0;
exports.iconDsfrInformationLine = exports.iconDsfrInformationFill = exports.iconDsfrArrowRightSLineDouble = exports.iconDsfrArrowRightSLastLine = exports.iconDsfrArrowLeftSLineDouble = exports.iconDsfrArrowLeftSFirstLine = exports.iconDsfrFilterLine = exports.iconDsfrFilterFill = exports.iconDsfrEyeOffLine = exports.iconDsfrEyeOffFill = exports.iconDsfrEyeLine = exports.iconDsfrEyeFill = exports.iconDsfrExternalLinkLine = exports.iconDsfrExternalLinkFill = exports.iconDsfrErrorWarningLine = exports.iconDsfrErrorWarningFill = exports.iconDsfrDownloadLine = exports.iconDsfrDownloadFill = exports.iconDsfrDeleteLine = exports.iconDsfrDeleteFill = exports.iconDsfrCloseLine = exports.iconDsfrCloseCircleLine = exports.iconDsfrCloseCircleFill = exports.iconDsfrCheckboxLine = exports.iconDsfrCheckboxFill = exports.iconDsfrCheckboxCircleLine = exports.iconDsfrCheckboxCircleFill = exports.iconDsfrCheckLine = exports.iconDsfrArrowUpSLine = exports.iconDsfrArrowUpSFill = exports.iconDsfrArrowUpLine = exports.iconDsfrArrowUpFill = exports.iconDsfrArrowRightUpLine = exports.iconDsfrArrowRightLine = exports.iconDsfrArrowRightFill = exports.iconDsfrArrowLeftLine = exports.iconDsfrArrowLeftFill = exports.iconDsfrArrowGoForwardLine = exports.iconDsfrArrowGoForwardFill = exports.iconDsfrArrowGoBackLine = exports.iconDsfrArrowGoBackFill = exports.iconDsfrArrowDownSLine = exports.iconDsfrArrowDownSFill = exports.iconDsfrArrowDownLine = exports.iconDsfrArrowDownFill = exports.iconDsfrAlertLine = exports.iconDsfrAlertFill = exports.iconDsfrAlarmWarningLine = exports.iconDsfrAlarmWarningFill = exports.iconDsfrAddLine = void 0;
exports.iconDsfrAccountFill = exports.iconDsfrAccountCircleLine = exports.iconDsfrAccountCircleFill = exports.dsfrIconsSystem = exports.iconDsfrAlertWarningFill = exports.iconDsfrAlertWarning2Fill = exports.iconDsfrArrowUpDownLine = exports.iconDsfrZoomOutLine = exports.iconDsfrZoomOutFill = exports.iconDsfrZoomInLine = exports.iconDsfrZoomInFill = exports.iconDsfrUploadLine = exports.iconDsfrUploadFill = exports.iconDsfrUpload2Line = exports.iconDsfrUpload2Fill = exports.iconDsfrTimerLine = exports.iconDsfrTimerFill = exports.iconDsfrTimeLine = exports.iconDsfrTimeFill = exports.iconDsfrThumbUpLine = exports.iconDsfrThumbUpFill = exports.iconDsfrThumbDownLine = exports.iconDsfrThumbDownFill = exports.iconDsfrSubtractLine = exports.iconDsfrStarSLine = exports.iconDsfrStarSFill = exports.iconDsfrStarLine = exports.iconDsfrStarFill = exports.iconDsfrShieldLine = exports.iconDsfrShieldFill = exports.iconDsfrSettings5Line = exports.iconDsfrSettings5Fill = exports.iconDsfrSearchLine = exports.iconDsfrSearchFill = exports.iconDsfrRefreshLine = exports.iconDsfrRefreshFill = exports.iconDsfrQuestionLine = exports.iconDsfrQuestionFill = exports.iconDsfrNotificationBadgeLine = exports.iconDsfrNotificationBadgeFill = exports.iconDsfrMoreLine = exports.iconDsfrMoreFill = exports.iconDsfrMenuFill = exports.iconDsfrMenu2Fill = exports.iconDsfrLogoutBoxRLine = exports.iconDsfrLogoutBoxRFill = exports.iconDsfrLockUnlockLine = exports.iconDsfrLockUnlockFill = exports.iconDsfrLockLine = exports.iconDsfrLockFill = void 0;
exports.iconDsfrTyphoonLine = exports.iconDsfrTyphoonFill = exports.iconDsfrTornadoLine = exports.iconDsfrTornadoFill = exports.iconDsfrThunderstormsLine = exports.iconDsfrThunderstormsFill = exports.iconDsfrTempColdLine = exports.iconDsfrTempColdFill = exports.iconDsfrSparkling2Line = exports.iconDsfrSparkling2Fill = exports.iconDsfrSnowyLine = exports.iconDsfrSnowyFill = exports.iconDsfrShowersLine = exports.iconDsfrShowersFill = exports.iconDsfrSubmersionFill = exports.iconDsfrAvalanchesFill = exports.iconDsfrFloodLine = exports.iconDsfrFloodFill = exports.iconDsfrFireLine = exports.iconDsfrFireFill = exports.iconDsfrMoonLine = exports.iconDsfrMoonFill = exports.iconDsfrFlashlightLine = exports.iconDsfrFlashlightFill = exports.iconDsfrCloudy2Line = exports.iconDsfrCloudy2Fill = exports.dsfrIconsUser = exports.iconDsfrUserStarLine = exports.iconDsfrUserStarFill = exports.iconDsfrUserSettingLine = exports.iconDsfrUserSettingFill = exports.iconDsfrUserSearchLine = exports.iconDsfrUserSearchFill = exports.iconDsfrUserHeartLine = exports.iconDsfrUserHeartFill = exports.iconDsfrUserLine = exports.iconDsfrUserFill = exports.iconDsfrUserAddLine = exports.iconDsfrUserAddFill = exports.iconDsfrTeamLine = exports.iconDsfrTeamFill = exports.iconDsfrParentLine = exports.iconDsfrParentFill = exports.iconDsfrGroupLine = exports.iconDsfrGroupFill = exports.iconDsfrAdminLine = exports.iconDsfrAdminFill = exports.iconDsfrAccountPinCircleLine = exports.iconDsfrAccountPinCircleFill = exports.iconDsfrAccountLine = void 0;
exports.dsfrIconsWeather = exports.iconDsfrWindyLine = exports.iconDsfrWindyFill = void 0;
exports.iconDsfrAncientGateFill = "fr-icon-ancient-gate-fill";
exports.iconDsfrAncientGateLine = "fr-icon-ancient-gate-line";
exports.iconDsfrAncientPavilionFill = "fr-icon-ancient-pavilion-fill";
exports.iconDsfrAncientPavilionLine = "fr-icon-ancient-pavilion-line";
exports.iconDsfrBankFill = "fr-icon-bank-fill";
exports.iconDsfrBankLine = "fr-icon-bank-line";
exports.iconDsfrBuildingFill = "fr-icon-building-fill";
exports.iconDsfrBuildingLine = "fr-icon-building-line";
exports.iconDsfrCommunityFill = "fr-icon-community-fill";
exports.iconDsfrCommunityLine = "fr-icon-community-line";
exports.iconDsfrGovernmentFill = "fr-icon-government-fill";
exports.iconDsfrGovernmentLine = "fr-icon-government-line";
exports.iconDsfrHome4Fill = "fr-icon-home-4-fill";
exports.iconDsfrHome4Line = "fr-icon-home-4-line";
exports.iconDsfrHospitalFill = "fr-icon-hospital-fill";
exports.iconDsfrHospitalLine = "fr-icon-hospital-line";
exports.iconDsfrHotelFill = "fr-icon-hotel-fill";
exports.iconDsfrHotelLine = "fr-icon-hotel-line";
exports.iconDsfrStoreFill = "fr-icon-store-fill";
exports.iconDsfrStoreLine = "fr-icon-store-line";
exports.dsfrIconsBuilding = [
    exports.iconDsfrAncientGateFill,
    exports.iconDsfrAncientGateLine,
    exports.iconDsfrAncientPavilionFill,
    exports.iconDsfrAncientPavilionLine,
    exports.iconDsfrBankFill,
    exports.iconDsfrBankLine,
    exports.iconDsfrBuildingFill,
    exports.iconDsfrBuildingLine,
    exports.iconDsfrCommunityFill,
    exports.iconDsfrCommunityLine,
    exports.iconDsfrGovernmentFill,
    exports.iconDsfrGovernmentLine,
    exports.iconDsfrHome4Fill,
    exports.iconDsfrHome4Line,
    exports.iconDsfrHospitalFill,
    exports.iconDsfrHospitalLine,
    exports.iconDsfrHotelFill,
    exports.iconDsfrHotelLine,
    exports.iconDsfrStoreFill,
    exports.iconDsfrStoreLine,
];
exports.iconDsfrArchiveFill = "fr-icon-archive-fill";
exports.iconDsfrArchiveLine = "fr-icon-archive-line";
exports.iconDsfrAttachmentFill = "fr-icon-attachment-fill";
exports.iconDsfrAttachmentLine = "fr-icon-attachment-line";
exports.iconDsfrAwardFill = "fr-icon-award-fill";
exports.iconDsfrAwardLine = "fr-icon-award-line";
exports.iconDsfrBarChartBoxFill = "fr-icon-bar-chart-box-fill";
exports.iconDsfrBarChartBoxLine = "fr-icon-bar-chart-box-line";
exports.iconDsfrBookmarkFill = "fr-icon-bookmark-fill";
exports.iconDsfrBookmarkLine = "fr-icon-bookmark-line";
exports.iconDsfrBriefcaseFill = "fr-icon-briefcase-fill";
exports.iconDsfrBriefcaseLine = "fr-icon-briefcase-line";
exports.iconDsfrCalendar2Fill = "fr-icon-calendar-2-fill";
exports.iconDsfrCalendar2Line = "fr-icon-calendar-2-line";
exports.iconDsfrCalendarEventFill = "fr-icon-calendar-event-fill";
exports.iconDsfrCalendarEventLine = "fr-icon-calendar-event-line";
exports.iconDsfrCalendarFill = "fr-icon-calendar-fill";
exports.iconDsfrCalendarLine = "fr-icon-calendar-line";
exports.iconDsfrCloudFill = "fr-icon-cloud-fill";
exports.iconDsfrCloudLine = "fr-icon-cloud-line";
exports.iconDsfrCopyrightFill = "fr-icon-copyright-fill";
exports.iconDsfrCopyrightLine = "fr-icon-copyright-line";
exports.iconDsfrCustomerServiceFill = "fr-icon-customer-service-fill";
exports.iconDsfrCustomerServiceLine = "fr-icon-customer-service-line";
exports.iconDsfrFlagFill = "fr-icon-flag-fill";
exports.iconDsfrFlagLine = "fr-icon-flag-line";
exports.iconDsfrGlobalFill = "fr-icon-global-fill";
exports.iconDsfrGlobalLine = "fr-icon-global-line";
exports.iconDsfrLineChartFill = "fr-icon-line-chart-fill";
exports.iconDsfrLineChartLine = "fr-icon-line-chart-line";
exports.iconDsfrLinksFill = "fr-icon-links-fill";
exports.iconDsfrLinksLine = "fr-icon-links-line";
exports.iconDsfrMailFill = "fr-icon-mail-fill";
exports.iconDsfrMailLine = "fr-icon-mail-line";
exports.iconDsfrMailOpenFill = "fr-icon-mail-open-fill";
exports.iconDsfrMailOpenLine = "fr-icon-mail-open-line";
exports.iconDsfrMedalFill = "fr-icon-medal-fill";
exports.iconDsfrMedalLine = "fr-icon-medal-line";
exports.iconDsfrPieChart2Fill = "fr-icon-pie-chart-2-fill";
exports.iconDsfrPieChart2Line = "fr-icon-pie-chart-2-line";
exports.iconDsfrPieChartBoxFill = "fr-icon-pie-chart-box-fill";
exports.iconDsfrPieChartBoxLine = "fr-icon-pie-chart-box-line";
exports.iconDsfrPrinterFill = "fr-icon-printer-fill";
exports.iconDsfrPrinterLine = "fr-icon-printer-line";
exports.iconDsfrProfilFill = "fr-icon-profil-fill";
exports.iconDsfrProfilLine = "fr-icon-profil-line";
exports.iconDsfrProjector2Fill = "fr-icon-projector-2-fill";
exports.iconDsfrProjector2Line = "fr-icon-projector-2-line";
exports.iconDsfrSendPlaneFill = "fr-icon-send-plane-fill";
exports.iconDsfrSendPlaneLine = "fr-icon-send-plane-line";
exports.iconDsfrSlideshowFill = "fr-icon-slideshow-fill";
exports.iconDsfrSlideshowLine = "fr-icon-slideshow-line";
exports.iconDsfrWindowFill = "fr-icon-window-fill";
exports.iconDsfrWindowLine = "fr-icon-window-line";
exports.dsfrIconsBusiness = [
    exports.iconDsfrArchiveFill,
    exports.iconDsfrArchiveLine,
    exports.iconDsfrAttachmentFill,
    exports.iconDsfrAttachmentLine,
    exports.iconDsfrAwardFill,
    exports.iconDsfrAwardLine,
    exports.iconDsfrBarChartBoxFill,
    exports.iconDsfrBarChartBoxLine,
    exports.iconDsfrBookmarkFill,
    exports.iconDsfrBookmarkLine,
    exports.iconDsfrBriefcaseFill,
    exports.iconDsfrBriefcaseLine,
    exports.iconDsfrCalendar2Fill,
    exports.iconDsfrCalendar2Line,
    exports.iconDsfrCalendarEventFill,
    exports.iconDsfrCalendarEventLine,
    exports.iconDsfrCalendarFill,
    exports.iconDsfrCalendarLine,
    exports.iconDsfrCloudFill,
    exports.iconDsfrCloudLine,
    exports.iconDsfrCopyrightFill,
    exports.iconDsfrCopyrightLine,
    exports.iconDsfrCustomerServiceFill,
    exports.iconDsfrCustomerServiceLine,
    exports.iconDsfrFlagFill,
    exports.iconDsfrFlagLine,
    exports.iconDsfrGlobalFill,
    exports.iconDsfrGlobalLine,
    exports.iconDsfrLineChartFill,
    exports.iconDsfrLineChartLine,
    exports.iconDsfrLinksFill,
    exports.iconDsfrLinksLine,
    exports.iconDsfrMailFill,
    exports.iconDsfrMailLine,
    exports.iconDsfrMailOpenFill,
    exports.iconDsfrMailOpenLine,
    exports.iconDsfrMedalFill,
    exports.iconDsfrMedalLine,
    exports.iconDsfrPieChart2Fill,
    exports.iconDsfrPieChart2Line,
    exports.iconDsfrPieChartBoxFill,
    exports.iconDsfrPieChartBoxLine,
    exports.iconDsfrPrinterFill,
    exports.iconDsfrPrinterLine,
    exports.iconDsfrProfilFill,
    exports.iconDsfrProfilLine,
    exports.iconDsfrProjector2Fill,
    exports.iconDsfrProjector2Line,
    exports.iconDsfrSendPlaneFill,
    exports.iconDsfrSendPlaneLine,
    exports.iconDsfrSlideshowFill,
    exports.iconDsfrSlideshowLine,
    exports.iconDsfrWindowFill,
    exports.iconDsfrWindowLine,
];
exports.iconDsfrChat2Fill = "fr-icon-chat-2-fill";
exports.iconDsfrChat2Line = "fr-icon-chat-2-line";
exports.iconDsfrChat3Fill = "fr-icon-chat-3-fill";
exports.iconDsfrChat3Line = "fr-icon-chat-3-line";
exports.iconDsfrChatCheckFill = "fr-icon-chat-check-fill";
exports.iconDsfrChatCheckLine = "fr-icon-chat-check-line";
exports.iconDsfrChatDeleteFill = "fr-icon-chat-delete-fill";
exports.iconDsfrChatDeleteLine = "fr-icon-chat-delete-line";
exports.iconDsfrChatPollFill = "fr-icon-chat-poll-fill";
exports.iconDsfrChatPollLine = "fr-icon-chat-poll-line";
exports.iconDsfrDiscussFill = "fr-icon-discuss-fill";
exports.iconDsfrDiscussLine = "fr-icon-discuss-line";
exports.iconDsfrFeedbackFill = "fr-icon-feedback-fill";
exports.iconDsfrFeedbackLine = "fr-icon-feedback-line";
exports.iconDsfrMessage2Fill = "fr-icon-message-2-fill";
exports.iconDsfrMessage2Line = "fr-icon-message-2-line";
exports.iconDsfrQuestionAnswerFill = "fr-icon-question-answer-fill";
exports.iconDsfrQuestionAnswerLine = "fr-icon-question-answer-line";
exports.iconDsfrQuestionnaireFill = "fr-icon-questionnaire-fill";
exports.iconDsfrQuestionnaireLine = "fr-icon-questionnaire-line";
exports.iconDsfrVideoChatFill = "fr-icon-video-chat-fill";
exports.iconDsfrVideoChatLine = "fr-icon-video-chat-line";
exports.dsfrIconsCommunication = [
    exports.iconDsfrChat2Fill,
    exports.iconDsfrChat2Line,
    exports.iconDsfrChat3Fill,
    exports.iconDsfrChat3Line,
    exports.iconDsfrChatCheckFill,
    exports.iconDsfrChatCheckLine,
    exports.iconDsfrChatDeleteFill,
    exports.iconDsfrChatDeleteLine,
    exports.iconDsfrChatPollFill,
    exports.iconDsfrChatPollLine,
    exports.iconDsfrDiscussFill,
    exports.iconDsfrDiscussLine,
    exports.iconDsfrFeedbackFill,
    exports.iconDsfrFeedbackLine,
    exports.iconDsfrMessage2Fill,
    exports.iconDsfrMessage2Line,
    exports.iconDsfrQuestionAnswerFill,
    exports.iconDsfrQuestionAnswerLine,
    exports.iconDsfrQuestionnaireFill,
    exports.iconDsfrQuestionnaireLine,
    exports.iconDsfrVideoChatFill,
    exports.iconDsfrVideoChatLine,
];
exports.iconDsfrBallPenFill = "fr-icon-ball-pen-fill";
exports.iconDsfrBallPenLine = "fr-icon-ball-pen-line";
exports.iconDsfrBrush3Fill = "fr-icon-brush-3-fill";
exports.iconDsfrBrush3Line = "fr-icon-brush-3-line";
exports.iconDsfrBrushFill = "fr-icon-brush-fill";
exports.iconDsfrBrushLine = "fr-icon-brush-line";
exports.iconDsfrContrastFill = "fr-icon-contrast-fill";
exports.iconDsfrContrastLine = "fr-icon-contrast-line";
exports.iconDsfrCropFill = "fr-icon-crop-fill";
exports.iconDsfrCropLine = "fr-icon-crop-line";
exports.iconDsfrDragMove2Fill = "fr-icon-drag-move-2-fill";
exports.iconDsfrDragMove2Line = "fr-icon-drag-move-2-line";
exports.iconDsfrDropFill = "fr-icon-drop-fill";
exports.iconDsfrDropLine = "fr-icon-drop-line";
exports.iconDsfrEditBoxFill = "fr-icon-edit-box-fill";
exports.iconDsfrEditBoxLine = "fr-icon-edit-box-line";
exports.iconDsfrEditFill = "fr-icon-edit-fill";
exports.iconDsfrEditLine = "fr-icon-edit-line";
exports.iconDsfrInkBottleFill = "fr-icon-ink-bottle-fill";
exports.iconDsfrInkBottleLine = "fr-icon-ink-bottle-line";
exports.iconDsfrLayoutGridFill = "fr-icon-layout-grid-fill";
exports.iconDsfrLayoutGridLine = "fr-icon-layout-grid-line";
exports.iconDsfrMarkPenFill = "fr-icon-mark-pen-fill";
exports.iconDsfrMarkPenLine = "fr-icon-mark-pen-line";
exports.iconDsfrPaintBrushFill = "fr-icon-paint-brush-fill";
exports.iconDsfrPaintBrushLine = "fr-icon-paint-brush-line";
exports.iconDsfrPaintFill = "fr-icon-paint-fill";
exports.iconDsfrPaintLine = "fr-icon-paint-line";
exports.iconDsfrPaletteFill = "fr-icon-palette-fill";
exports.iconDsfrPaletteLine = "fr-icon-palette-line";
exports.iconDsfrPantoneFill = "fr-icon-pantone-fill";
exports.iconDsfrPantoneLine = "fr-icon-pantone-line";
exports.iconDsfrPenNibFill = "fr-icon-pen-nib-fill";
exports.iconDsfrPenNibLine = "fr-icon-pen-nib-line";
exports.iconDsfrPencilFill = "fr-icon-pencil-fill";
exports.iconDsfrPencilLine = "fr-icon-pencil-line";
exports.iconDsfrPencilRulerFill = "fr-icon-pencil-ruler-fill";
exports.iconDsfrPencilRulerLine = "fr-icon-pencil-ruler-line";
exports.iconDsfrSipFill = "fr-icon-sip-fill";
exports.iconDsfrSipLine = "fr-icon-sip-line";
exports.iconDsfrTableFill = "fr-icon-table-fill";
exports.iconDsfrTableLine = "fr-icon-table-line";
exports.iconDsfrShapesFill = "shapes-fill";
exports.iconDsfrShapesLine = "shapes-line";
exports.dsfrIconsDesign = [
    exports.iconDsfrBallPenFill,
    exports.iconDsfrBallPenLine,
    exports.iconDsfrBrush3Fill,
    exports.iconDsfrBrush3Line,
    exports.iconDsfrBrushFill,
    exports.iconDsfrBrushLine,
    exports.iconDsfrContrastFill,
    exports.iconDsfrContrastLine,
    exports.iconDsfrCropFill,
    exports.iconDsfrCropLine,
    exports.iconDsfrDragMove2Fill,
    exports.iconDsfrDragMove2Line,
    exports.iconDsfrDropFill,
    exports.iconDsfrDropLine,
    exports.iconDsfrEditBoxFill,
    exports.iconDsfrEditBoxLine,
    exports.iconDsfrEditFill,
    exports.iconDsfrEditLine,
    exports.iconDsfrInkBottleFill,
    exports.iconDsfrInkBottleLine,
    exports.iconDsfrLayoutGridFill,
    exports.iconDsfrLayoutGridLine,
    exports.iconDsfrMarkPenFill,
    exports.iconDsfrMarkPenLine,
    exports.iconDsfrPaintBrushFill,
    exports.iconDsfrPaintBrushLine,
    exports.iconDsfrPaintFill,
    exports.iconDsfrPaintLine,
    exports.iconDsfrPaletteFill,
    exports.iconDsfrPaletteLine,
    exports.iconDsfrPantoneFill,
    exports.iconDsfrPantoneLine,
    exports.iconDsfrPenNibFill,
    exports.iconDsfrPenNibLine,
    exports.iconDsfrPencilFill,
    exports.iconDsfrPencilLine,
    exports.iconDsfrPencilRulerFill,
    exports.iconDsfrPencilRulerLine,
    exports.iconDsfrSipFill,
    exports.iconDsfrSipLine,
    exports.iconDsfrTableFill,
    exports.iconDsfrTableLine,
    exports.iconDsfrShapesFill,
    exports.iconDsfrShapesLine
];
exports.iconDsfrBugFill = "fr-icon-bug-fill";
exports.iconDsfrBugLine = "fr-icon-bug-line";
exports.iconDsfrCodeBoxFill = "fr-icon-code-box-fill";
exports.iconDsfrCodeBoxLine = "fr-icon-code-box-line";
exports.iconDsfrCodeSSlashLine = "fr-icon-code-s-slash-line";
exports.iconDsfrCursorFill = "fr-icon-cursor-fill";
exports.iconDsfrCursorLine = "fr-icon-cursor-line";
exports.iconDsfrGitBranchFill = "fr-icon-git-branch-fill";
exports.iconDsfrGitBranchLine = "fr-icon-git-branch-line";
exports.iconDsfrGitCommitFill = "fr-icon-git-commit-fill";
exports.iconDsfrGitCommitLine = "fr-icon-git-commit-line";
exports.iconDsfrGitMergeFill = "fr-icon-git-merge-fill";
exports.iconDsfrGitMergeLine = "fr-icon-git-merge-line";
exports.iconDsfrGitPullRequestFill = "fr-icon-git-pull-request-fill";
exports.iconDsfrGitPullRequestLine = "fr-icon-git-pull-request-line";
exports.iconDsfrGitRepositoryCommitsFill = "fr-icon-git-repository-commits-fill";
exports.iconDsfrGitRepositoryCommitsLine = "fr-icon-git-repository-commits-line";
exports.iconDsfrGitRepositoryFill = "fr-icon-git-repository-fill";
exports.iconDsfrGitRepositoryLine = "fr-icon-git-repository-line";
exports.iconDsfrGitRepositoryPrivateFill = "fr-icon-git-repository-private-fill";
exports.iconDsfrGitRepositoryPrivateLine = "fr-icon-git-repository-private-line";
exports.iconDsfrTerminalBoxFill = "fr-icon-terminal-box-fill";
exports.iconDsfrTerminalBoxLine = "fr-icon-terminal-box-line";
exports.iconDsfrTerminalLine = "fr-icon-terminal-line";
exports.iconDsfrTerminalWindowFill = "fr-icon-terminal-window-fill";
exports.iconDsfrTerminalWindowLine = "fr-icon-terminal-window-line";
exports.dsfrIconsDevelopment = [
    exports.iconDsfrBugFill,
    exports.iconDsfrBugLine,
    exports.iconDsfrCodeBoxFill,
    exports.iconDsfrCodeBoxLine,
    exports.iconDsfrCodeSSlashLine,
    exports.iconDsfrCursorFill,
    exports.iconDsfrCursorLine,
    exports.iconDsfrGitBranchFill,
    exports.iconDsfrGitBranchLine,
    exports.iconDsfrGitCommitFill,
    exports.iconDsfrGitCommitLine,
    exports.iconDsfrGitMergeFill,
    exports.iconDsfrGitMergeLine,
    exports.iconDsfrGitPullRequestFill,
    exports.iconDsfrGitPullRequestLine,
    exports.iconDsfrGitRepositoryCommitsFill,
    exports.iconDsfrGitRepositoryCommitsLine,
    exports.iconDsfrGitRepositoryFill,
    exports.iconDsfrGitRepositoryLine,
    exports.iconDsfrGitRepositoryPrivateFill,
    exports.iconDsfrGitRepositoryPrivateLine,
    exports.iconDsfrTerminalBoxFill,
    exports.iconDsfrTerminalBoxLine,
    exports.iconDsfrTerminalLine,
    exports.iconDsfrTerminalWindowFill,
    exports.iconDsfrTerminalWindowLine,
];
exports.iconDsfrBluetoothFill = "fr-icon-bluetooth-fill";
exports.iconDsfrBluetoothLine = "fr-icon-bluetooth-line";
exports.iconDsfrComputerFill = "fr-icon-computer-fill";
exports.iconDsfrComputerLine = "fr-icon-computer-line";
exports.iconDsfrDashboard3Fill = "fr-icon-dashboard-3-fill";
exports.iconDsfrDashboard3Line = "fr-icon-dashboard-3-line";
exports.iconDsfrDatabaseFill = "fr-icon-database-fill";
exports.iconDsfrDatabaseLine = "fr-icon-database-line";
exports.iconDsfrDeviceFill = "fr-icon-device-fill";
exports.iconDsfrDeviceLine = "fr-icon-device-line";
exports.iconDsfrHardDrive2Fill = "fr-icon-hard-drive-2-fill";
exports.iconDsfrHardDrive2Line = "fr-icon-hard-drive-2-line";
exports.iconDsfrMacFill = "fr-icon-mac-fill";
exports.iconDsfrMacLine = "fr-icon-mac-line";
exports.iconDsfrPhoneFill = "fr-icon-phone-fill";
exports.iconDsfrPhoneLine = "fr-icon-phone-line";
exports.iconDsfrQrCodeFill = "fr-icon-qr-code-fill";
exports.iconDsfrQrCodeLine = "fr-icon-qr-code-line";
exports.iconDsfrRssFill = "fr-icon-rss-fill";
exports.iconDsfrRssLine = "fr-icon-rss-line";
exports.iconDsfrSave3Fill = "fr-icon-save-3-fill";
exports.iconDsfrSave3Line = "fr-icon-save-3-line";
exports.iconDsfrSaveFill = "fr-icon-save-fill";
exports.iconDsfrSaveLine = "fr-icon-save-line";
exports.iconDsfrServerFill = "fr-icon-server-fill";
exports.iconDsfrServerLine = "fr-icon-server-line";
exports.iconDsfrSmartphoneFill = "fr-icon-smartphone-fill";
exports.iconDsfrSmartphoneLine = "fr-icon-smartphone-line";
exports.iconDsfrTabletFill = "fr-icon-tablet-fill";
exports.iconDsfrTabletLine = "fr-icon-tablet-line";
exports.iconDsfrTvFill = "fr-icon-tv-fill";
exports.iconDsfrTvLine = "fr-icon-tv-line";
exports.iconDsfrWifiFill = "fr-icon-wifi-fill";
exports.iconDsfrWifiLine = "fr-icon-wifi-line";
exports.dsfrIconsDevice = [
    exports.iconDsfrBluetoothFill,
    exports.iconDsfrBluetoothLine,
    exports.iconDsfrComputerFill,
    exports.iconDsfrComputerLine,
    exports.iconDsfrDashboard3Fill,
    exports.iconDsfrDashboard3Line,
    exports.iconDsfrDatabaseFill,
    exports.iconDsfrDatabaseLine,
    exports.iconDsfrDeviceFill,
    exports.iconDsfrDeviceLine,
    exports.iconDsfrHardDrive2Fill,
    exports.iconDsfrHardDrive2Line,
    exports.iconDsfrMacFill,
    exports.iconDsfrMacLine,
    exports.iconDsfrPhoneFill,
    exports.iconDsfrPhoneLine,
    exports.iconDsfrQrCodeFill,
    exports.iconDsfrQrCodeLine,
    exports.iconDsfrRssFill,
    exports.iconDsfrRssLine,
    exports.iconDsfrSave3Fill,
    exports.iconDsfrSave3Line,
    exports.iconDsfrSaveFill,
    exports.iconDsfrSaveLine,
    exports.iconDsfrServerFill,
    exports.iconDsfrServerLine,
    exports.iconDsfrSmartphoneFill,
    exports.iconDsfrSmartphoneLine,
    exports.iconDsfrTabletFill,
    exports.iconDsfrTabletLine,
    exports.iconDsfrTvFill,
    exports.iconDsfrTvLine,
    exports.iconDsfrWifiFill,
    exports.iconDsfrWifiLine,
];
exports.iconDsfrArticleFill = "fr-icon-article-fill";
exports.iconDsfrArticleLine = "fr-icon-article-line";
exports.iconDsfrBook2Fill = "fr-icon-book-2-fill";
exports.iconDsfrBook2Line = "fr-icon-book-2-line";
exports.iconDsfrBookletFill = "fr-icon-booklet-fill";
exports.iconDsfrBookletLine = "fr-icon-booklet-line";
exports.iconDsfrClipboardFill = "fr-icon-clipboard-fill";
exports.iconDsfrClipboardLine = "fr-icon-clipboard-line";
exports.iconDsfrDraftFill = "fr-icon-draft-fill";
exports.iconDsfrDraftLine = "fr-icon-draft-line";
exports.iconDsfrFileAddFill = "fr-icon-file-add-fill";
exports.iconDsfrFileAddLine = "fr-icon-file-add-line";
exports.iconDsfrFileDownloadFill = "fr-icon-file-download-fill";
exports.iconDsfrFileDownloadLine = "fr-icon-file-download-line";
exports.iconDsfrFileFill = "fr-icon-file-fill";
exports.iconDsfrFileLine = "fr-icon-file-line";
exports.iconDsfrFilePdfFill = "fr-icon-file-pdf-fill";
exports.iconDsfrFilePdfLine = "fr-icon-file-pdf-line";
exports.iconDsfrFileTextFill = "fr-icon-file-text-fill";
exports.iconDsfrFileTextLine = "fr-icon-file-text-line";
exports.iconDsfrFolder2Fill = "fr-icon-folder-2-fill";
exports.iconDsfrFolder2Line = "fr-icon-folder-2-line";
exports.iconDsfrNewspaperFill = "fr-icon-newspaper-fill";
exports.iconDsfrNewspaperLine = "fr-icon-newspaper-line";
exports.iconDsfrSurveyFill = "fr-icon-survey-fill";
exports.iconDsfrSurveyLine = "fr-icon-survey-line";
exports.iconDsfrTodoFill = "fr-icon-todo-fill";
exports.iconDsfrTodoLine = "fr-icon-todo-line";
exports.dsfrIconsDocument = [
    exports.iconDsfrArticleFill,
    exports.iconDsfrArticleLine,
    exports.iconDsfrBook2Fill,
    exports.iconDsfrBook2Line,
    exports.iconDsfrBookletFill,
    exports.iconDsfrBookletLine,
    exports.iconDsfrClipboardFill,
    exports.iconDsfrClipboardLine,
    exports.iconDsfrDraftFill,
    exports.iconDsfrDraftLine,
    exports.iconDsfrFileAddFill,
    exports.iconDsfrFileAddLine,
    exports.iconDsfrFileDownloadFill,
    exports.iconDsfrFileDownloadLine,
    exports.iconDsfrFileFill,
    exports.iconDsfrFileLine,
    exports.iconDsfrFilePdfFill,
    exports.iconDsfrFilePdfLine,
    exports.iconDsfrFileTextFill,
    exports.iconDsfrFileTextLine,
    exports.iconDsfrFolder2Fill,
    exports.iconDsfrFolder2Line,
    exports.iconDsfrNewspaperFill,
    exports.iconDsfrNewspaperLine,
    exports.iconDsfrSurveyFill,
    exports.iconDsfrSurveyLine,
    exports.iconDsfrTodoFill,
    exports.iconDsfrTodoLine,
];
exports.iconDsfrBold = "fr-icon-bold";
exports.iconDsfrHighlight = "fr-icon-highlight";
exports.iconDsfrQuoteFill = "fr-icon-quote-fill";
exports.iconDsfrQuoteLine = "fr-icon-quote-line";
exports.iconDsfrCodeView = "fr-icon-code-view";
exports.iconDsfrFontSize = "fr-icon-font-size";
exports.iconDsfrH1 = "fr-icon-h-1";
exports.iconDsfrH2 = "fr-icon-h-2";
exports.iconDsfrH3 = "fr-icon-h-3";
exports.iconDsfrH4 = "fr-icon-h-4";
exports.iconDsfrH5 = "fr-icon-h-5";
exports.iconDsfrH6 = "fr-icon-h-6";
exports.iconDsfrHashtag = "fr-icon-hashtag";
exports.iconDsfrItalic = "fr-icon-italic";
exports.iconDsfrLinkUnlink = "fr-icon-link-unlink";
exports.iconDsfrLink = "fr-icon-link";
exports.iconDsfrListOrdered = "fr-icon-list-ordered";
exports.iconDsfrListUnordered = "fr-icon-list-unordered";
exports.iconDsfrListQuestionMark = "fr-icon-question-mark";
exports.iconDsfrSeparator = "fr-icon-separator";
exports.iconDsfrSpace = "fr-icon-space";
exports.iconDsfrSubscript = "fr-icon-subscript";
exports.iconDsfrSuperscript = "fr-icon-superscript";
exports.iconDsfrTable2 = "fr-icon-table-2";
exports.iconDsfrTranslate2 = "fr-icon-translate-2";
exports.dsfrIconsEditor = [
    exports.iconDsfrBold,
    exports.iconDsfrHighlight,
    exports.iconDsfrQuoteFill,
    exports.iconDsfrQuoteLine,
    exports.iconDsfrCodeView,
    exports.iconDsfrFontSize,
    exports.iconDsfrH1,
    exports.iconDsfrH2,
    exports.iconDsfrH3,
    exports.iconDsfrH4,
    exports.iconDsfrH5,
    exports.iconDsfrH6,
    exports.iconDsfrHashtag,
    exports.iconDsfrItalic,
    exports.iconDsfrLinkUnlink,
    exports.iconDsfrLink,
    exports.iconDsfrListOrdered,
    exports.iconDsfrListUnordered,
    exports.iconDsfrListQuestionMark,
    exports.iconDsfrSeparator,
    exports.iconDsfrSpace,
    exports.iconDsfrSubscript,
    exports.iconDsfrSuperscript,
    exports.iconDsfrTable2,
    exports.iconDsfrTranslate2,
];
exports.iconDsfrBankCardFill = "fr-icon-bank-card-fill";
exports.iconDsfrBankCardLine = "fr-icon-bank-card-line";
exports.iconDsfrCoinFill = "fr-icon-coin-fill";
exports.iconDsfrGiftFill = "fr-icon-gift-fill";
exports.iconDsfrGiftLine = "fr-icon-gift-line";
exports.iconDsfrMoneyEuroBoxFill = "fr-icon-money-euro-box-fill";
exports.iconDsfrMoneyEuroBoxLine = "fr-icon-money-euro-box-line";
exports.iconDsfrMoneyEuroCircleFill = "fr-icon-money-euro-circle-fill";
exports.iconDsfrMoneyEuroCircleLine = "fr-icon-money-euro-circle-line";
exports.iconDsfrSecurePaymentFill = "fr-icon-secure-payment-fill";
exports.iconDsfrSecurePaymentLine = "fr-icon-secure-payment-line";
exports.iconDsfrShoppingBagFill = "fr-icon-shopping-bag-fill";
exports.iconDsfrShoppingBagLine = "fr-icon-shopping-bag-line";
exports.iconDsfrShoppingCart2Fill = "fr-icon-shopping-cart-2-fill";
exports.iconDsfrShoppingCart2Line = "fr-icon-shopping-cart-2-line";
exports.iconDsfrTrophyFill = "fr-icon-trophy-fill";
exports.iconDsfrTrophyLine = "fr-icon-trophy-line";
exports.dsfrIconsFinance = [
    exports.iconDsfrBankCardFill,
    exports.iconDsfrBankCardLine,
    exports.iconDsfrCoinFill,
    exports.iconDsfrGiftFill,
    exports.iconDsfrGiftLine,
    exports.iconDsfrMoneyEuroBoxFill,
    exports.iconDsfrMoneyEuroBoxLine,
    exports.iconDsfrMoneyEuroCircleFill,
    exports.iconDsfrMoneyEuroCircleLine,
    exports.iconDsfrSecurePaymentFill,
    exports.iconDsfrSecurePaymentLine,
    exports.iconDsfrShoppingBagFill,
    exports.iconDsfrShoppingBagLine,
    exports.iconDsfrShoppingCart2Fill,
    exports.iconDsfrShoppingCart2Line,
    exports.iconDsfrTrophyFill,
    exports.iconDsfrTrophyLine,
];
exports.iconDsfrCapsuleFill = "fr-icon-capsule-fill";
exports.iconDsfrCapsuleLine = "fr-icon-capsule-line";
exports.iconDsfrDislikeFill = "fr-icon-dislike-fill";
exports.iconDsfrDislikeLine = "fr-icon-dislike-line";
exports.iconDsfrDossierFill = "fr-icon-dossier-fill";
exports.iconDsfrDossierLine = "fr-icon-dossier-line";
exports.iconDsfrFirstAidKitFill = "fr-icon-first-aid-kit-fill";
exports.iconDsfrFirstAidKitLine = "fr-icon-first-aid-kit-line";
exports.iconDsfrHandSanitizerFill = "fr-icon-hand-sanitizer-fill";
exports.iconDsfrHandSanitizerLine = "fr-icon-hand-sanitizer-line";
exports.iconDsfrHealthBookFill = "fr-icon-health-book-fill";
exports.iconDsfrHealthBookLine = "fr-icon-health-book-line";
exports.iconDsfrHeartFill = "fr-icon-heart-fill";
exports.iconDsfrHeartLine = "fr-icon-heart-line";
exports.iconDsfrHeartPulseFill = "fr-icon-heart-pulse-fill";
exports.iconDsfrHeartPulseLine = "fr-icon-heart-pulse-line";
exports.iconDsfrLungsFill = "fr-icon-lungs-fill";
exports.iconDsfrLungsLine = "fr-icon-lungs-line";
exports.iconDsfrMedicineBottleFill = "fr-icon-medicine-bottle-fill";
exports.iconDsfrMedicineBottleLine = "fr-icon-medicine-bottle-line";
exports.iconDsfrMentalHealthFill = "fr-icon-mental-health-fill";
exports.iconDsfrMentalHealthLine = "fr-icon-mental-health-line";
exports.iconDsfrMicroscopeFill = "fr-icon-microscope-fill";
exports.iconDsfrMicroscopeLine = "fr-icon-microscope-line";
exports.iconDsfrPsychotherapyFill = "fr-icon-psychotherapy-fill";
exports.iconDsfrPsychotherapyLine = "fr-icon-psychotherapy-line";
exports.iconDsfrPulseLine = "fr-icon-pulse-line";
exports.iconDsfrStethoscopeFill = "fr-icon-stethoscope-fill";
exports.iconDsfrStethoscopeLine = "fr-icon-stethoscope-line";
exports.iconDsfrSurgicalMaskFill = "fr-icon-surgical-mask-fill";
exports.iconDsfrSurgicalMaskLine = "fr-icon-surgical-mask-line";
exports.iconDsfrSyringeFill = "fr-icon-syringe-fill";
exports.iconDsfrSyringeLine = "fr-icon-syringe-line";
exports.iconDsfrTestTubeFill = "fr-icon-test-tube-fill";
exports.iconDsfrTestTubeLine = "fr-icon-test-tube-line";
exports.iconDsfrThermometerFill = "fr-icon-thermometer-fill";
exports.iconDsfrThermometerLine = "fr-icon-thermometer-line";
exports.iconDsfrVirusFill = "fr-icon-virus-fill";
exports.iconDsfrVirusLine = "fr-icon-virus-line";
exports.dsfrIconsHealth = [
    exports.iconDsfrCapsuleFill,
    exports.iconDsfrCapsuleLine,
    exports.iconDsfrDislikeFill,
    exports.iconDsfrDislikeLine,
    exports.iconDsfrDossierFill,
    exports.iconDsfrDossierLine,
    exports.iconDsfrFirstAidKitFill,
    exports.iconDsfrFirstAidKitLine,
    exports.iconDsfrHandSanitizerFill,
    exports.iconDsfrHandSanitizerLine,
    exports.iconDsfrHealthBookFill,
    exports.iconDsfrHealthBookLine,
    exports.iconDsfrHeartFill,
    exports.iconDsfrHeartLine,
    exports.iconDsfrHeartPulseFill,
    exports.iconDsfrHeartPulseLine,
    exports.iconDsfrLungsFill,
    exports.iconDsfrLungsLine,
    exports.iconDsfrMedicineBottleFill,
    exports.iconDsfrMedicineBottleLine,
    exports.iconDsfrMentalHealthFill,
    exports.iconDsfrMentalHealthLine,
    exports.iconDsfrMicroscopeFill,
    exports.iconDsfrMicroscopeLine,
    exports.iconDsfrPsychotherapyFill,
    exports.iconDsfrPsychotherapyLine,
    exports.iconDsfrPulseLine,
    exports.iconDsfrStethoscopeFill,
    exports.iconDsfrStethoscopeLine,
    exports.iconDsfrSurgicalMaskFill,
    exports.iconDsfrSurgicalMaskLine,
    exports.iconDsfrSyringeFill,
    exports.iconDsfrSyringeLine,
    exports.iconDsfrTestTubeFill,
    exports.iconDsfrTestTubeLine,
    exports.iconDsfrThermometerFill,
    exports.iconDsfrThermometerLine,
    exports.iconDsfrVirusFill,
    exports.iconDsfrVirusLine,
];
exports.iconDsfrDailymotionFill = "fr-icon-dailymotion-fill";
exports.iconDsfrDailymotionLine = "fr-icon-dailymotion-line";
exports.iconDsfrTiktokFill = "fr-icon-tiktok-fill";
exports.iconDsfrTiktokLine = "fr-icon-tiktok-line";
exports.iconDsfrChromeFill = "fr-icon-chrome-fill";
exports.iconDsfrChromeLine = "fr-icon-chrome-line";
exports.iconDsfrEdgeFill = "fr-icon-edge-fill";
exports.iconDsfrEdgeLine = "fr-icon-edge-line";
exports.iconDsfrFacebookCircleFill = "fr-icon-facebook-circle-fill";
exports.iconDsfrFacebookCircleLine = "fr-icon-facebook-circle-line";
exports.iconDsfrFirefoxFill = "fr-icon-firefox-fill";
exports.iconDsfrFirefoxLine = "fr-icon-firefox-line";
exports.iconDsfrGithubFill = "fr-icon-github-fill";
exports.iconDsfrGithubLine = "fr-icon-github-line";
exports.iconDsfrGoogleFill = "fr-icon-google-fill";
exports.iconDsfrGoogleLine = "fr-icon-google-line";
exports.iconDsfrIeFill = "fr-icon-ie-fill";
exports.iconDsfrIeLine = "fr-icon-ie-line";
exports.iconDsfrInstagramFill = "fr-icon-instagram-fill";
exports.iconDsfrInstagramLine = "fr-icon-instagram-line";
exports.iconDsfrLinkedinBoxFill = "fr-icon-linkedin-box-fill";
exports.iconDsfrLinkedinBoxLine = "fr-icon-linkedin-box-line";
exports.iconDsfrMastodonFill = "fr-icon-mastodon-fill";
exports.iconDsfrMastodonLine = "fr-icon-mastodon-line";
exports.iconDsfrNpmjsFill = "fr-icon-npmjs-fill";
exports.iconDsfrNpmjsLine = "fr-icon-npmjs-line";
exports.iconDsfrRemixiconFill = "fr-icon-remixicon-fill";
exports.iconDsfrRemixiconLine = "fr-icon-remixicon-line";
exports.iconDsfrSafariFill = "fr-icon-safari-fill";
exports.iconDsfrSafariLine = "fr-icon-safari-line";
exports.iconDsfrSlackFill = "fr-icon-slack-fill";
exports.iconDsfrSlackLine = "fr-icon-slack-line";
exports.iconDsfrSnapchatFill = "fr-icon-snapchat-fill";
exports.iconDsfrSnapchatLine = "fr-icon-snapchat-line";
exports.iconDsfrTelegramFill = "fr-icon-telegram-fill";
exports.iconDsfrTelegramLine = "fr-icon-telegram-line";
exports.iconDsfrTwitchFill = "fr-icon-twitch-fill";
exports.iconDsfrTwitchLine = "fr-icon-twitch-line";
exports.iconDsfrTwitterFill = "fr-icon-twitter-fill";
exports.iconDsfrTwitterLine = "fr-icon-twitter-line";
exports.iconDsfrVimeoFill = "fr-icon-vimeo-fill";
exports.iconDsfrVimeoLine = "fr-icon-vimeo-line";
exports.iconDsfrVuejsFill = "fr-icon-vuejs-fill";
exports.iconDsfrVuejsLine = "fr-icon-vuejs-line";
exports.iconDsfrYoutubeFill = "fr-icon-youtube-fill";
exports.iconDsfrYoutubeLine = "fr-icon-youtube-line";
exports.iconDsfrWhatsappFill = "fr-icon-whatsapp-fill";
exports.iconDsfrWhatsappLine = "fr-icon-whatsapp-line";
exports.dsfrIconsLogo = [
    exports.iconDsfrDailymotionFill,
    exports.iconDsfrDailymotionLine,
    exports.iconDsfrTiktokFill,
    exports.iconDsfrTiktokLine,
    exports.iconDsfrChromeFill,
    exports.iconDsfrChromeLine,
    exports.iconDsfrEdgeFill,
    exports.iconDsfrEdgeLine,
    exports.iconDsfrFacebookCircleFill,
    exports.iconDsfrFacebookCircleLine,
    exports.iconDsfrFirefoxFill,
    exports.iconDsfrFirefoxLine,
    exports.iconDsfrGithubFill,
    exports.iconDsfrGithubLine,
    exports.iconDsfrGoogleFill,
    exports.iconDsfrGoogleLine,
    exports.iconDsfrIeFill,
    exports.iconDsfrIeLine,
    exports.iconDsfrInstagramFill,
    exports.iconDsfrInstagramLine,
    exports.iconDsfrLinkedinBoxFill,
    exports.iconDsfrLinkedinBoxLine,
    exports.iconDsfrMastodonFill,
    exports.iconDsfrMastodonLine,
    exports.iconDsfrNpmjsFill,
    exports.iconDsfrNpmjsLine,
    exports.iconDsfrRemixiconFill,
    exports.iconDsfrRemixiconLine,
    exports.iconDsfrSafariFill,
    exports.iconDsfrSafariLine,
    exports.iconDsfrSlackFill,
    exports.iconDsfrSlackLine,
    exports.iconDsfrSnapchatFill,
    exports.iconDsfrSnapchatLine,
    exports.iconDsfrTelegramFill,
    exports.iconDsfrTelegramLine,
    exports.iconDsfrTwitchFill,
    exports.iconDsfrTwitchLine,
    exports.iconDsfrTwitterFill,
    exports.iconDsfrTwitterLine,
    exports.iconDsfrVimeoFill,
    exports.iconDsfrVimeoLine,
    exports.iconDsfrVuejsFill,
    exports.iconDsfrVuejsLine,
    exports.iconDsfrYoutubeFill,
    exports.iconDsfrYoutubeLine,
    exports.iconDsfrWhatsappFill,
    exports.iconDsfrWhatsappLine
];
exports.iconDsfrAnchorFill = "fr-icon-anchor-fill";
exports.iconDsfrAnchorLine = "fr-icon-anchor-line";
exports.iconDsfrBikeFill = "fr-icon-bike-fill";
exports.iconDsfrBikeLine = "fr-icon-bike-line";
exports.iconDsfrBusFill = "fr-icon-bus-fill";
exports.iconDsfrBusLine = "fr-icon-bus-line";
exports.iconDsfrCarFill = "fr-icon-car-fill";
exports.iconDsfrCarLine = "fr-icon-car-line";
exports.iconDsfrCaravanFill = "fr-icon-caravan-fill";
exports.iconDsfrCaravanLine = "fr-icon-caravan-line";
exports.iconDsfrChargingPile2Fill = "fr-icon-charging-pile-2-fill";
exports.iconDsfrChargingPile2Line = "fr-icon-charging-pile-2-line";
exports.iconDsfrCompass3Fill = "fr-icon-compass-3-fill";
exports.iconDsfrCompass3Line = "fr-icon-compass-3-line";
exports.iconDsfrCupFill = "fr-icon-cup-fill";
exports.iconDsfrCupLine = "fr-icon-cup-line";
exports.iconDsfrEarthFill = "fr-icon-earth-fill";
exports.iconDsfrEarthLine = "fr-icon-earth-line";
exports.iconDsfrFranceFill = "fr-icon-france-fill";
exports.iconDsfrFranceLine = "fr-icon-france-line";
exports.iconDsfrGasStationFill = "fr-icon-gas-station-fill";
exports.iconDsfrGasStationLine = "fr-icon-gas-station-line";
exports.iconDsfrGobletFill = "fr-icon-goblet-fill";
exports.iconDsfrGobletLine = "fr-icon-goblet-line";
exports.iconDsfrMapPin2Fill = "fr-icon-map-pin-2-fill";
exports.iconDsfrMapPin2Line = "fr-icon-map-pin-2-line";
exports.iconDsfrMapPinUserFill = "fr-icon-map-pin-user-fill";
exports.iconDsfrMapPinUserLine = "fr-icon-map-pin-user-line";
exports.iconDsfrMotorbikeFill = "fr-icon-motorbike-fill";
exports.iconDsfrMotorbikeLine = "fr-icon-motorbike-line";
exports.iconDsfrPassportFill = "fr-icon-passport-fill";
exports.iconDsfrPassportLine = "fr-icon-passport-line";
exports.iconDsfrRestaurantFill = "fr-icon-restaurant-fill";
exports.iconDsfrRestaurantLine = "fr-icon-restaurant-line";
exports.iconDsfrRoadMapFill = "fr-icon-road-map-fill";
exports.iconDsfrRoadMapLine = "fr-icon-road-map-line";
exports.iconDsfrSailboatFill = "fr-icon-sailboat-fill";
exports.iconDsfrSailboatLine = "fr-icon-sailboat-line";
exports.iconDsfrShip2Fill = "fr-icon-ship-2-fill";
exports.iconDsfrShip2Line = "fr-icon-ship-2-line";
exports.iconDsfrSignalTowerFill = "fr-icon-signal-tower-fill";
exports.iconDsfrSignalTowerLine = "fr-icon-signal-tower-line";
exports.iconDsfrSuitcase2Fill = "fr-icon-suitcase-2-fill";
exports.iconDsfrSuitcase2Line = "fr-icon-suitcase-2-line";
exports.iconDsfrTaxiFill = "fr-icon-taxi-fill";
exports.iconDsfrTaxiLine = "fr-icon-taxi-line";
exports.iconDsfrTrainFill = "fr-icon-train-fill";
exports.iconDsfrTrainLine = "fr-icon-train-line";
exports.iconDsfrXFill = "fr-icon-twitter-x-fill";
exports.iconDsfrXLine = "fr-icon-twitter-x-line";
exports.iconDsfrThreadsFill = "fr-icon-threads-fill";
exports.iconDsfrThreadsLine = "fr-icon-threads-line";
exports.iconDsfrPlayCircleFill = "fr-icon-play-circle-fill";
exports.iconDsfrPlayCircleLine = "fr-icon-play-circle-line";
exports.iconDsfrStopCircleFill = "fr-icon-stop-circle-fill";
exports.iconDsfrStopCircleLine = "fr-icon-stop-circle-line";
exports.dsfrIconsMap = [
    exports.iconDsfrAnchorFill,
    exports.iconDsfrAnchorLine,
    exports.iconDsfrBikeFill,
    exports.iconDsfrBikeLine,
    exports.iconDsfrBusFill,
    exports.iconDsfrBusLine,
    exports.iconDsfrCarFill,
    exports.iconDsfrCarLine,
    exports.iconDsfrCaravanFill,
    exports.iconDsfrCaravanLine,
    exports.iconDsfrChargingPile2Fill,
    exports.iconDsfrChargingPile2Line,
    exports.iconDsfrCompass3Fill,
    exports.iconDsfrCompass3Line,
    exports.iconDsfrCupFill,
    exports.iconDsfrCupLine,
    exports.iconDsfrEarthFill,
    exports.iconDsfrEarthLine,
    exports.iconDsfrFranceFill,
    exports.iconDsfrFranceLine,
    exports.iconDsfrGasStationFill,
    exports.iconDsfrGasStationLine,
    exports.iconDsfrGobletFill,
    exports.iconDsfrGobletLine,
    exports.iconDsfrMapPin2Fill,
    exports.iconDsfrMapPin2Line,
    exports.iconDsfrMapPinUserFill,
    exports.iconDsfrMapPinUserLine,
    exports.iconDsfrMotorbikeFill,
    exports.iconDsfrMotorbikeLine,
    exports.iconDsfrPassportFill,
    exports.iconDsfrPassportLine,
    exports.iconDsfrRestaurantFill,
    exports.iconDsfrRestaurantLine,
    exports.iconDsfrRoadMapFill,
    exports.iconDsfrRoadMapLine,
    exports.iconDsfrSailboatFill,
    exports.iconDsfrSailboatLine,
    exports.iconDsfrShip2Fill,
    exports.iconDsfrShip2Line,
    exports.iconDsfrSignalTowerFill,
    exports.iconDsfrSignalTowerLine,
    exports.iconDsfrSuitcase2Fill,
    exports.iconDsfrSuitcase2Line,
    exports.iconDsfrTaxiFill,
    exports.iconDsfrTaxiLine,
    exports.iconDsfrTrainFill,
    exports.iconDsfrTrainLine,
    exports.iconDsfrXFill,
    exports.iconDsfrXLine,
    exports.iconDsfrThreadsFill,
    exports.iconDsfrThreadsLine,
    exports.iconDsfrPlayCircleFill,
    exports.iconDsfrPlayCircleLine,
    exports.iconDsfrStopCircleFill,
    exports.iconDsfrStopCircleLine
];
exports.iconDsfrCameraFill = "fr-icon-camera-fill";
exports.iconDsfrCameraLine = "fr-icon-camera-line";
exports.iconDsfrClapperboardFill = "fr-icon-clapperboard-fill";
exports.iconDsfrClapperboardLine = "fr-icon-clapperboard-line";
exports.iconDsfrEqualizerFill = "fr-icon-equalizer-fill";
exports.iconDsfrEqualizerLine = "fr-icon-equalizer-line";
exports.iconDsfrFilmFill = "fr-icon-film-fill";
exports.iconDsfrFilmLine = "fr-icon-film-line";
exports.iconDsfrGalleryFill = "fr-icon-gallery-fill";
exports.iconDsfrGalleryLine = "fr-icon-gallery-line";
exports.iconDsfrHeadphoneFill = "fr-icon-headphone-fill";
exports.iconDsfrHeadphoneLine = "fr-icon-headphone-line";
exports.iconDsfrImageAddFill = "fr-icon-image-add-fill";
exports.iconDsfrImageAddLine = "fr-icon-image-add-line";
exports.iconDsfrImageEditFill = "fr-icon-image-edit-fill";
exports.iconDsfrImageEditLine = "fr-icon-image-edit-line";
exports.iconDsfrImageFill = "fr-icon-image-fill";
exports.iconDsfrImageLine = "fr-icon-image-line";
exports.iconDsfrLiveFill = "fr-icon-live-fill";
exports.iconDsfrLiveLine = "fr-icon-live-line";
exports.iconDsfrMicFill = "fr-icon-mic-fill";
exports.iconDsfrMicLine = "fr-icon-mic-line";
exports.iconDsfrMusic2Fill = "fr-icon-music-2-fill";
exports.iconDsfrMusic2Line = "fr-icon-music-2-line";
exports.iconDsfrNotification3Fill = "fr-icon-notification-3-fill";
exports.iconDsfrNotification3Line = "fr-icon-notification-3-line";
exports.iconDsfrPauseCircleFill = "fr-icon-pause-circle-fill";
exports.iconDsfrPauseCircleLine = "fr-icon-pause-circle-line";
exports.iconDsfrVolumeDownFill = "fr-icon-volume-down-fill";
exports.iconDsfrVolumeDownLine = "fr-icon-volume-down-line";
exports.iconDsfrVolumeMuteFill = "fr-icon-volume-mute-fill";
exports.iconDsfrVolumeMuteLine = "fr-icon-volume-mute-line";
exports.iconDsfrVolumeUpFill = "fr-icon-volume-up-fill";
exports.iconDsfrVolumeUpLine = "fr-icon-volume-up-line";
exports.dsfrIconsMedia = [
    exports.iconDsfrCameraFill,
    exports.iconDsfrCameraLine,
    exports.iconDsfrClapperboardFill,
    exports.iconDsfrClapperboardLine,
    exports.iconDsfrEqualizerFill,
    exports.iconDsfrEqualizerLine,
    exports.iconDsfrFilmFill,
    exports.iconDsfrFilmLine,
    exports.iconDsfrGalleryFill,
    exports.iconDsfrGalleryLine,
    exports.iconDsfrHeadphoneFill,
    exports.iconDsfrHeadphoneLine,
    exports.iconDsfrImageAddFill,
    exports.iconDsfrImageAddLine,
    exports.iconDsfrImageEditFill,
    exports.iconDsfrImageEditLine,
    exports.iconDsfrImageFill,
    exports.iconDsfrImageLine,
    exports.iconDsfrLiveFill,
    exports.iconDsfrLiveLine,
    exports.iconDsfrMicFill,
    exports.iconDsfrMicLine,
    exports.iconDsfrMusic2Fill,
    exports.iconDsfrMusic2Line,
    exports.iconDsfrNotification3Fill,
    exports.iconDsfrNotification3Line,
    exports.iconDsfrPauseCircleFill,
    exports.iconDsfrPauseCircleLine,
    exports.iconDsfrVolumeDownFill,
    exports.iconDsfrVolumeDownLine,
    exports.iconDsfrVolumeMuteFill,
    exports.iconDsfrVolumeMuteLine,
    exports.iconDsfrVolumeUpFill,
    exports.iconDsfrVolumeUpLine,
];
exports.iconDsfrLeafFill = "fr-icon-leaf-fill";
exports.iconDsfrLeafLine = "fr-icon-leaf-line";
exports.iconDsfrLightbulbFill = "fr-icon-lightbulb-fill";
exports.iconDsfrLightbulbLine = "fr-icon-lightbulb-line";
exports.iconDsfrPlantFill = "fr-icon-plant-fill";
exports.iconDsfrPlantLine = "fr-icon-plant-line";
exports.iconDsfrRecycleFill = "fr-icon-recycle-fill";
exports.iconDsfrRecycleLine = "fr-icon-recycle-line";
exports.iconDsfrScales3Fill = "fr-icon-scales-3-fill";
exports.iconDsfrScales3Line = "fr-icon-scales-3-line";
exports.iconDsfrSeedlingFill = "fr-icon-seedling-fill";
exports.iconDsfrSeedlingLine = "fr-icon-seedling-line";
exports.iconDsfrUmbrellaFill = "fr-icon-umbrella-fill";
exports.iconDsfrUmbrellaLine = "fr-icon-umbrella-line";
exports.iconDsfrAccessibilityFill = "fr-icon-accessibility-fill";
exports.iconDsfrAccessibilityLine = "fr-icon-accessibility-line";
exports.iconDsfrEarOffFill = "fr-icon-ear-off-fill";
exports.iconDsfrEarOffLine = "fr-icon-ear-off-line";
exports.iconDsfrMentalDisabilitiesFill = "fr-icon-mental-disabilities-fill";
exports.iconDsfrMentalDisabilitiesLine = "fr-icon-mental-disabilities-line";
exports.iconDsfrSignLanguageFill = "fr-icon-sign-language-fill";
exports.iconDsfrSignLanguageLine = "fr-icon-sign-language-line";
exports.iconDsfrWheelchairFill = "fr-icon-wheelchair-fill";
exports.iconDsfrWheelchairLine = "fr-icon-wheelchair-line";
exports.dsfrIconsOthers = [
    exports.iconDsfrLeafFill,
    exports.iconDsfrLeafLine,
    exports.iconDsfrLightbulbFill,
    exports.iconDsfrLightbulbLine,
    exports.iconDsfrPlantFill,
    exports.iconDsfrPlantLine,
    exports.iconDsfrRecycleFill,
    exports.iconDsfrRecycleLine,
    exports.iconDsfrScales3Fill,
    exports.iconDsfrScales3Line,
    exports.iconDsfrSeedlingFill,
    exports.iconDsfrSeedlingLine,
    exports.iconDsfrUmbrellaFill,
    exports.iconDsfrUmbrellaLine,
    exports.iconDsfrAccessibilityFill,
    exports.iconDsfrAccessibilityLine,
    exports.iconDsfrEarOffFill,
    exports.iconDsfrEarOffLine,
    exports.iconDsfrMentalDisabilitiesFill,
    exports.iconDsfrMentalDisabilitiesLine,
    exports.iconDsfrSignLanguageFill,
    exports.iconDsfrSignLanguageLine,
    exports.iconDsfrWheelchairFill,
    exports.iconDsfrWheelchairLine
];
exports.iconDsfrArrowLeftSFill = "fr-icon-arrow-left-s-fill";
exports.iconDsfrArrowLeftSLine = "fr-icon-arrow-left-s-line";
exports.iconDsfrArrowRightSFill = "fr-icon-arrow-right-s-fill";
exports.iconDsfrArrowRightSLine = "fr-icon-arrow-right-s-line";
exports.iconDsfrErrorFill = "fr-icon-error-fill";
exports.iconDsfrErrorLine = "fr-icon-error-line";
exports.iconDsfrInfoFill = "fr-icon-info-fill";
exports.iconDsfrInfoLine = "fr-icon-info-line";
exports.iconDsfrSuccessFill = "fr-icon-success-fill";
exports.iconDsfrSuccessLine = "fr-icon-success-line";
exports.iconDsfrWarningFill = "fr-icon-warning-fill";
exports.iconDsfrWarningLine = "fr-icon-warning-line";
exports.iconDsfrThemeFill = "fr-icon-theme-fill";
exports.iconDsfrAddCircleFill = "fr-icon-add-circle-fill";
exports.iconDsfrAddCircleLine = "fr-icon-add-circle-line";
exports.iconDsfrAddLine = "fr-icon-add-line";
exports.iconDsfrAlarmWarningFill = "fr-icon-alarm-warning-fill";
exports.iconDsfrAlarmWarningLine = "fr-icon-alarm-warning-line";
exports.iconDsfrAlertFill = "fr-icon-alert-fill";
exports.iconDsfrAlertLine = "fr-icon-alert-line";
exports.iconDsfrArrowDownFill = "fr-icon-arrow-down-fill";
exports.iconDsfrArrowDownLine = "fr-icon-arrow-down-line";
exports.iconDsfrArrowDownSFill = "fr-icon-arrow-down-s-fill";
exports.iconDsfrArrowDownSLine = "fr-icon-arrow-down-s-line";
exports.iconDsfrArrowGoBackFill = "fr-icon-arrow-go-back-fill";
exports.iconDsfrArrowGoBackLine = "fr-icon-arrow-go-back-line";
exports.iconDsfrArrowGoForwardFill = "fr-icon-arrow-go-forward-fill";
exports.iconDsfrArrowGoForwardLine = "fr-icon-arrow-go-forward-line";
exports.iconDsfrArrowLeftFill = "fr-icon-arrow-left-fill";
exports.iconDsfrArrowLeftLine = "fr-icon-arrow-left-line";
exports.iconDsfrArrowRightFill = "fr-icon-arrow-right-fill";
exports.iconDsfrArrowRightLine = "fr-icon-arrow-right-line";
exports.iconDsfrArrowRightUpLine = "fr-icon-arrow-right-up-line";
exports.iconDsfrArrowUpFill = "fr-icon-arrow-up-fill";
exports.iconDsfrArrowUpLine = "fr-icon-arrow-up-line";
exports.iconDsfrArrowUpSFill = "fr-icon-arrow-up-s-fill";
exports.iconDsfrArrowUpSLine = "fr-icon-arrow-up-s-line";
exports.iconDsfrCheckLine = "fr-icon-check-line";
exports.iconDsfrCheckboxCircleFill = "fr-icon-checkbox-circle-fill";
exports.iconDsfrCheckboxCircleLine = "fr-icon-checkbox-circle-line";
exports.iconDsfrCheckboxFill = "fr-icon-checkbox-fill";
exports.iconDsfrCheckboxLine = "fr-icon-checkbox-line";
exports.iconDsfrCloseCircleFill = "fr-icon-close-circle-fill";
exports.iconDsfrCloseCircleLine = "fr-icon-close-circle-line";
exports.iconDsfrCloseLine = "fr-icon-close-line";
exports.iconDsfrDeleteFill = "fr-icon-delete-fill";
exports.iconDsfrDeleteLine = "fr-icon-delete-line";
exports.iconDsfrDownloadFill = "fr-icon-download-fill";
exports.iconDsfrDownloadLine = "fr-icon-download-line";
exports.iconDsfrErrorWarningFill = "fr-icon-error-warning-fill";
exports.iconDsfrErrorWarningLine = "fr-icon-error-warning-line";
exports.iconDsfrExternalLinkFill = "fr-icon-external-link-fill";
exports.iconDsfrExternalLinkLine = "fr-icon-external-link-line";
exports.iconDsfrEyeFill = "fr-icon-eye-fill";
exports.iconDsfrEyeLine = "fr-icon-eye-line";
exports.iconDsfrEyeOffFill = "fr-icon-eye-off-fill";
exports.iconDsfrEyeOffLine = "fr-icon-eye-off-line";
exports.iconDsfrFilterFill = "fr-icon-filter-fill";
exports.iconDsfrFilterLine = "fr-icon-filter-line";
exports.iconDsfrArrowLeftSFirstLine = "fr-icon-arrow-left-s-first-line";
exports.iconDsfrArrowLeftSLineDouble = "fr-icon-arrow-left-s-line-double";
exports.iconDsfrArrowRightSLastLine = "fr-icon-arrow-right-s-last-line";
exports.iconDsfrArrowRightSLineDouble = "fr-icon-arrow-right-s-line-double";
exports.iconDsfrInformationFill = "fr-icon-information-fill";
exports.iconDsfrInformationLine = "fr-icon-information-line";
exports.iconDsfrLockFill = "fr-icon-lock-fill";
exports.iconDsfrLockLine = "fr-icon-lock-line";
exports.iconDsfrLockUnlockFill = "fr-icon-lock-unlock-fill";
exports.iconDsfrLockUnlockLine = "fr-icon-lock-unlock-line";
exports.iconDsfrLogoutBoxRFill = "fr-icon-logout-box-r-fill";
exports.iconDsfrLogoutBoxRLine = "fr-icon-logout-box-r-line";
exports.iconDsfrMenu2Fill = "fr-icon-menu-2-fill";
exports.iconDsfrMenuFill = "fr-icon-menu-fill";
exports.iconDsfrMoreFill = "fr-icon-more-fill";
exports.iconDsfrMoreLine = "fr-icon-more-line";
exports.iconDsfrNotificationBadgeFill = "fr-icon-notification-badge-fill";
exports.iconDsfrNotificationBadgeLine = "fr-icon-notification-badge-line";
exports.iconDsfrQuestionFill = "fr-icon-question-fill";
exports.iconDsfrQuestionLine = "fr-icon-question-line";
exports.iconDsfrRefreshFill = "fr-icon-refresh-fill";
exports.iconDsfrRefreshLine = "fr-icon-refresh-line";
exports.iconDsfrSearchFill = "fr-icon-search-fill";
exports.iconDsfrSearchLine = "fr-icon-search-line";
exports.iconDsfrSettings5Fill = "fr-icon-settings-5-fill";
exports.iconDsfrSettings5Line = "fr-icon-settings-5-line";
exports.iconDsfrShieldFill = "fr-icon-shield-fill";
exports.iconDsfrShieldLine = "fr-icon-shield-line";
exports.iconDsfrStarFill = "fr-icon-star-fill";
exports.iconDsfrStarLine = "fr-icon-star-line";
exports.iconDsfrStarSFill = "fr-icon-star-s-fill";
exports.iconDsfrStarSLine = "fr-icon-star-s-line";
exports.iconDsfrSubtractLine = "fr-icon-subtract-line";
exports.iconDsfrThumbDownFill = "fr-icon-thumb-down-fill";
exports.iconDsfrThumbDownLine = "fr-icon-thumb-down-line";
exports.iconDsfrThumbUpFill = "fr-icon-thumb-up-fill";
exports.iconDsfrThumbUpLine = "fr-icon-thumb-up-line";
exports.iconDsfrTimeFill = "fr-icon-time-fill";
exports.iconDsfrTimeLine = "fr-icon-time-line";
exports.iconDsfrTimerFill = "fr-icon-timer-fill";
exports.iconDsfrTimerLine = "fr-icon-timer-line";
exports.iconDsfrUpload2Fill = "fr-icon-upload-2-fill";
exports.iconDsfrUpload2Line = "fr-icon-upload-2-line";
exports.iconDsfrUploadFill = "fr-icon-upload-fill";
exports.iconDsfrUploadLine = "fr-icon-upload-line";
exports.iconDsfrZoomInFill = "fr-icon-zoom-in-fill";
exports.iconDsfrZoomInLine = "fr-icon-zoom-in-line";
exports.iconDsfrZoomOutFill = "fr-icon-zoom-out-fill";
exports.iconDsfrZoomOutLine = "fr-icon-zoom-out-line";
exports.iconDsfrArrowUpDownLine = "fr-icon-arrow-up-down-line";
exports.iconDsfrAlertWarning2Fill = "fr-icon-alert-warning-2-fill";
exports.iconDsfrAlertWarningFill = "fr-icon-alert-warning-fill";
exports.dsfrIconsSystem = [
    exports.iconDsfrArrowLeftSFill,
    exports.iconDsfrArrowLeftSLine,
    exports.iconDsfrArrowRightSFill,
    exports.iconDsfrArrowRightSLine,
    exports.iconDsfrErrorFill,
    exports.iconDsfrErrorLine,
    exports.iconDsfrInfoFill,
    exports.iconDsfrInfoLine,
    exports.iconDsfrSuccessFill,
    exports.iconDsfrSuccessLine,
    exports.iconDsfrWarningFill,
    exports.iconDsfrWarningLine,
    exports.iconDsfrThemeFill,
    exports.iconDsfrAddCircleFill,
    exports.iconDsfrAddCircleLine,
    exports.iconDsfrAddLine,
    exports.iconDsfrAlarmWarningFill,
    exports.iconDsfrAlarmWarningLine,
    exports.iconDsfrAlertFill,
    exports.iconDsfrAlertLine,
    exports.iconDsfrArrowDownFill,
    exports.iconDsfrArrowDownLine,
    exports.iconDsfrArrowDownSFill,
    exports.iconDsfrArrowDownSLine,
    exports.iconDsfrArrowGoBackFill,
    exports.iconDsfrArrowGoBackLine,
    exports.iconDsfrArrowGoForwardFill,
    exports.iconDsfrArrowGoForwardLine,
    exports.iconDsfrArrowLeftFill,
    exports.iconDsfrArrowLeftLine,
    exports.iconDsfrArrowRightFill,
    exports.iconDsfrArrowRightLine,
    exports.iconDsfrArrowRightUpLine,
    exports.iconDsfrArrowUpFill,
    exports.iconDsfrArrowUpLine,
    exports.iconDsfrArrowUpSFill,
    exports.iconDsfrArrowUpSLine,
    exports.iconDsfrCheckLine,
    exports.iconDsfrCheckboxCircleFill,
    exports.iconDsfrCheckboxCircleLine,
    exports.iconDsfrCheckboxFill,
    exports.iconDsfrCheckboxLine,
    exports.iconDsfrCloseCircleFill,
    exports.iconDsfrCloseCircleLine,
    exports.iconDsfrCloseLine,
    exports.iconDsfrDeleteFill,
    exports.iconDsfrDeleteLine,
    exports.iconDsfrDownloadFill,
    exports.iconDsfrDownloadLine,
    exports.iconDsfrErrorWarningFill,
    exports.iconDsfrErrorWarningLine,
    exports.iconDsfrExternalLinkFill,
    exports.iconDsfrExternalLinkLine,
    exports.iconDsfrEyeFill,
    exports.iconDsfrEyeLine,
    exports.iconDsfrEyeOffFill,
    exports.iconDsfrEyeOffLine,
    exports.iconDsfrFilterFill,
    exports.iconDsfrFilterLine,
    exports.iconDsfrArrowLeftSFirstLine,
    exports.iconDsfrArrowLeftSLineDouble,
    exports.iconDsfrArrowRightSLastLine,
    exports.iconDsfrArrowRightSLineDouble,
    exports.iconDsfrInformationFill,
    exports.iconDsfrInformationLine,
    exports.iconDsfrLockFill,
    exports.iconDsfrLockLine,
    exports.iconDsfrLockUnlockFill,
    exports.iconDsfrLockUnlockLine,
    exports.iconDsfrLogoutBoxRFill,
    exports.iconDsfrLogoutBoxRLine,
    exports.iconDsfrMenu2Fill,
    exports.iconDsfrMenuFill,
    exports.iconDsfrMoreFill,
    exports.iconDsfrMoreLine,
    exports.iconDsfrNotificationBadgeFill,
    exports.iconDsfrNotificationBadgeLine,
    exports.iconDsfrQuestionFill,
    exports.iconDsfrQuestionLine,
    exports.iconDsfrRefreshFill,
    exports.iconDsfrRefreshLine,
    exports.iconDsfrSearchFill,
    exports.iconDsfrSearchLine,
    exports.iconDsfrSettings5Fill,
    exports.iconDsfrSettings5Line,
    exports.iconDsfrShieldFill,
    exports.iconDsfrShieldLine,
    exports.iconDsfrStarFill,
    exports.iconDsfrStarLine,
    exports.iconDsfrStarSFill,
    exports.iconDsfrStarSLine,
    exports.iconDsfrSubtractLine,
    exports.iconDsfrThumbDownFill,
    exports.iconDsfrThumbDownLine,
    exports.iconDsfrThumbUpFill,
    exports.iconDsfrThumbUpLine,
    exports.iconDsfrTimeFill,
    exports.iconDsfrTimeLine,
    exports.iconDsfrTimerFill,
    exports.iconDsfrTimerLine,
    exports.iconDsfrUpload2Fill,
    exports.iconDsfrUpload2Line,
    exports.iconDsfrUploadFill,
    exports.iconDsfrUploadLine,
    exports.iconDsfrZoomInFill,
    exports.iconDsfrZoomInLine,
    exports.iconDsfrZoomOutFill,
    exports.iconDsfrZoomOutLine,
    exports.iconDsfrArrowUpDownLine,
    exports.iconDsfrAlertWarning2Fill,
    exports.iconDsfrAlertWarningFill
];
exports.iconDsfrAccountCircleFill = "fr-icon-account-circle-fill";
exports.iconDsfrAccountCircleLine = "fr-icon-account-circle-line";
exports.iconDsfrAccountFill = "fr-icon-account-fill";
exports.iconDsfrAccountLine = "fr-icon-account-line";
exports.iconDsfrAccountPinCircleFill = "fr-icon-account-pin-circle-fill";
exports.iconDsfrAccountPinCircleLine = "fr-icon-account-pin-circle-line";
exports.iconDsfrAdminFill = "fr-icon-admin-fill";
exports.iconDsfrAdminLine = "fr-icon-admin-line";
exports.iconDsfrGroupFill = "fr-icon-group-fill";
exports.iconDsfrGroupLine = "fr-icon-group-line";
exports.iconDsfrParentFill = "fr-icon-parent-fill";
exports.iconDsfrParentLine = "fr-icon-parent-line";
exports.iconDsfrTeamFill = "fr-icon-team-fill";
exports.iconDsfrTeamLine = "fr-icon-team-line";
exports.iconDsfrUserAddFill = "fr-icon-user-add-fill";
exports.iconDsfrUserAddLine = "fr-icon-user-add-line";
exports.iconDsfrUserFill = "fr-icon-user-fill";
exports.iconDsfrUserLine = "fr-icon-user-line";
exports.iconDsfrUserHeartFill = "fr-icon-user-heart-fill";
exports.iconDsfrUserHeartLine = "fr-icon-user-heart-line";
exports.iconDsfrUserSearchFill = "fr-icon-user-search-fill";
exports.iconDsfrUserSearchLine = "fr-icon-user-search-line";
exports.iconDsfrUserSettingFill = "fr-icon-user-setting-fill";
exports.iconDsfrUserSettingLine = "fr-icon-user-setting-line";
exports.iconDsfrUserStarFill = "fr-icon-user-star-fill";
exports.iconDsfrUserStarLine = "fr-icon-user-star-line";
exports.dsfrIconsUser = [
    exports.iconDsfrAccountCircleFill,
    exports.iconDsfrAccountCircleLine,
    exports.iconDsfrAccountFill,
    exports.iconDsfrAccountLine,
    exports.iconDsfrAccountPinCircleFill,
    exports.iconDsfrAccountPinCircleLine,
    exports.iconDsfrAdminFill,
    exports.iconDsfrAdminLine,
    exports.iconDsfrGroupFill,
    exports.iconDsfrGroupLine,
    exports.iconDsfrParentFill,
    exports.iconDsfrParentLine,
    exports.iconDsfrTeamFill,
    exports.iconDsfrTeamLine,
    exports.iconDsfrUserAddFill,
    exports.iconDsfrUserAddLine,
    exports.iconDsfrUserFill,
    exports.iconDsfrUserLine,
    exports.iconDsfrUserHeartFill,
    exports.iconDsfrUserHeartLine,
    exports.iconDsfrUserSearchFill,
    exports.iconDsfrUserSearchLine,
    exports.iconDsfrUserSettingFill,
    exports.iconDsfrUserSettingLine,
    exports.iconDsfrUserStarFill,
    exports.iconDsfrUserStarLine,
];
exports.iconDsfrCloudy2Fill = "fr-icon-cloudy-2-fill";
exports.iconDsfrCloudy2Line = "fr-icon-cloudy-2-line";
exports.iconDsfrFlashlightFill = "fr-icon-flashlight-fill";
exports.iconDsfrFlashlightLine = "fr-icon-flashlight-line";
exports.iconDsfrMoonFill = "fr-icon-moon-fill";
exports.iconDsfrMoonLine = "fr-icon-moon-line";
exports.iconDsfrFireFill = "fr-icon-fire-fill";
exports.iconDsfrFireLine = "fr-icon-fire-line";
exports.iconDsfrFloodFill = "fr-icon-flood-fill";
exports.iconDsfrFloodLine = "fr-icon-flood-line";
exports.iconDsfrAvalanchesFill = "fr-icon-avalanches-fill";
exports.iconDsfrSubmersionFill = "fr-icon-submersion-fill";
exports.iconDsfrShowersFill = "fr-icon-heavy-showers-fill";
exports.iconDsfrShowersLine = "fr-icon-heavy-showers-line";
exports.iconDsfrSnowyFill = "fr-icon-snowy-fill";
exports.iconDsfrSnowyLine = "fr-icon-snowy-line";
exports.iconDsfrSparkling2Fill = "fr-icon-sparkling-2-fill";
exports.iconDsfrSparkling2Line = "fr-icon-sparkling-2-line";
exports.iconDsfrTempColdFill = "fr-icon-temp-cold-fill";
exports.iconDsfrTempColdLine = "fr-icon-temp-cold-line";
exports.iconDsfrThunderstormsFill = "fr-icon-thunderstorms-fill";
exports.iconDsfrThunderstormsLine = "fr-icon-thunderstorms-line";
exports.iconDsfrTornadoFill = "fr-icon-tornado-fill";
exports.iconDsfrTornadoLine = "fr-icon-tornado-line";
exports.iconDsfrTyphoonFill = "fr-icon-typhoon-fill";
exports.iconDsfrTyphoonLine = "fr-icon-typhoon-line";
exports.iconDsfrWindyFill = "fr-icon-windy-fill";
exports.iconDsfrWindyLine = "fr-icon-windy-line";
exports.dsfrIconsWeather = [
    exports.iconDsfrCloudy2Fill,
    exports.iconDsfrCloudy2Line,
    exports.iconDsfrFlashlightFill,
    exports.iconDsfrFlashlightLine,
    exports.iconDsfrMoonFill,
    exports.iconDsfrMoonLine,
    exports.iconDsfrFireFill,
    exports.iconDsfrFireLine,
    exports.iconDsfrFloodFill,
    exports.iconDsfrFloodLine,
    exports.iconDsfrAvalanchesFill,
    exports.iconDsfrSubmersionFill,
    exports.iconDsfrShowersFill,
    exports.iconDsfrShowersLine,
    exports.iconDsfrSnowyFill,
    exports.iconDsfrSnowyLine,
    exports.iconDsfrSparkling2Fill,
    exports.iconDsfrSparkling2Line,
    exports.iconDsfrTempColdFill,
    exports.iconDsfrTempColdLine,
    exports.iconDsfrThunderstormsFill,
    exports.iconDsfrThunderstormsLine,
    exports.iconDsfrTornadoFill,
    exports.iconDsfrTornadoLine,
    exports.iconDsfrTyphoonFill,
    exports.iconDsfrTyphoonLine,
    exports.iconDsfrWindyFill,
    exports.iconDsfrWindyLine
];
